webpackJsonpHairCare(["core"],{

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\add-to-cart\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true Foundation:true */


exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _strings = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\strings.js");

var _gaServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\ga-services.js");

var _klaviyoServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\klaviyo-services.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = "app.core/modules/cart";
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_SELECTOR = "[data-add-to-cart]";
var PROGRESS_CLASS = "is-submitting";
var SUCCESS_CLASS = "is-submitted";
var PRODUCT_ID_ATTR = "data-product-id";
var PRICE_ATTR = "data-price";
var HIDE_CLASS = "u-hide";
var ERROR_CONTAINER_SELECTOR = "[data-add-to-cart-error-message]";

//  todo pull these from CMS editable page somehow
var validationMessages = {
	// empty: 'What quantity would you like quoted?',
	// min: 'What quantity would you like quoted?',
	// max: 'Sorry you can’t order more than {{max}}',
	integer: $("meta[name=\"site.addToCartValidation.integer\"]").attr("content") || "Oops! Enter the number as digits only please.",
	connection: $("meta[name=\"site.addToCartValidation.connection\"]").attr("content") || "An error occurred sending your request to the server. Please try again later."
};

var quantityTests = [
// {
//     //  is not empty
//     test: value => value !== '',
//     message: 'empty'
// },
{
	// is integer
	test: function test(value) {
		return Number.isInteger(value);
	},
	message: "integer"
}];

function getMessage(messageName, context) {
	var message = validationMessages[messageName] || false;
	return context ? (0, _strings.tmpl)(message, context) : message;
}

//  Note the {max} value here is not needed
//  left as example of rendering a dynamic value into a error message
function validateQty(value, max) {
	var error = quantityTests.reduce(function (result, validator) {
		return result ? result : validator.test(value, max) ? false : getMessage(validator.message, { max: max });
	}, false);

	//  Return true or error message encountered
	return error;
}

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var AddToCartPlugin = function () {
	function AddToCartPlugin(element, options) {
		_classCallCheck(this, AddToCartPlugin);

		this.element = element;
		this.options = options;
		this.$element = $(element);

		this.codeVal = this.options.code;
		if (!this.codeVal) {
			log('Product code not specified. Use data-add-to-cart-code="XXXX" Aborting.');
			return false;
		}

		this.$qtyField = this.$element.find(this.options.qtyField);
		this.hasQtyField = this.$qtyField.length === 1;

		this.maxQty = this.hasQtyField && typeof getJSONValue(this.$qtyField.attr("max")) === 'number' ? this.$qtyField.attr("max") : this.options.maxQty;

		this.$addToCartButton = this.$element.find(this.options.submitButton);
		this.productId = this.$element.attr(PRODUCT_ID_ATTR);
		this.price = this.$element.attr(PRICE_ATTR);

		this.$headerCartLink = $(this.options.cartLink);
		this.$errorElement = this.$element.find(this.options.errorElement);
		this.errorClassname = this.options.errorClassname;
		this.$productElement = this.$element.closest(this.options.productElementSelector);
		this.notificationElement = document.querySelector(this.options.notificationElementSelector);
		this.cart = document.querySelector(this.options.cartSelector);

		this.updateEventTarget = this.cart || this.notificationElement;

		this.submitFadeTimeout = undefined;

		this.posts = [];

		log("AddToCartPlugin", element);

		this.watch();
		this.quantity = 1;
	}

	_createClass(AddToCartPlugin, [{
		key: "getQtyInputErrors",
		value: function getQtyInputErrors() {
			if (!this.hasQtyField) {
				return false;
			}

			// Validate entered input QTY value (not over max, is number)
			return validateQty(+this.getQty(), +this.maxQty);
		}
	}, {
		key: "onQtyInput",
		value: function onQtyInput(event) {
			//  ignore: enter, shift, alt, tab, meta key strokes (meta has multiple codes)
			var ignoreKeys = [13, 16, 18, 9, 91, 92, 93, 224];

			//  Ignore keystrokes with modifier key
			if (ignoreKeys.indexOf(event.which) !== -1) {
				return true;
			}

			var error = this.getQtyInputErrors();

			if (error) {
				this.handleErrors([error], "client");
			} else {
				this.clearErrors();
			}
		}
	}, {
		key: "onAddQtyExit",
		value: function onAddQtyExit() {
			var value = this.$qtyField.val().trim();

			// Clear entered 0 or whitespace from QTY input
			// if value is emptish: '', '0'
			if (value === "" || value === "0") {
				this.clearErrors();
				this.$qtyField.val("");
			}
		}
	}, {
		key: "catchEnter",
		value: function catchEnter(event) {
			if (event.which === 13 /* enter */) {
					event.preventDefault();
					this.submit();
				}
		}
	}, {
		key: "onAjaxSubmit",
		value: function onAjaxSubmit(event) {
			event.preventDefault();
			this.submit();
		}
	}, {
		key: "getQty",
		value: function getQty() {
			if (this.hasQtyField) {
				var inputValue = this.$qtyField.val().trim();

				// if value is '' return default
				return inputValue === '' ? this.options.qty : inputValue;
			}
			return this.options.qty;
		}
	}, {
		key: "submit",
		value: function submit() {
			var error = this.getQtyInputErrors();

			if (error) {
				this.handleErrors([error], "client");
				return false;
			}

			log("submitted", this.$element);
			this.$addToCartButton.removeClass(SUCCESS_CLASS);
			clearTimeout(this.submitFadeTimeout);
			this.$addToCartButton.addClass(PROGRESS_CLASS).attr("disabled", "disabled");
			this.post();
		}
	}, {
		key: "watch",
		value: function watch() {
			log("ajax", this.options.ajax);

			this.$addToCartButton.on("click.addToCart", this.onAjaxSubmit.bind(this));

			if (this.hasQtyField) {

				//  avoid submitting containing product listing filter form
				this.$qtyField.on("keydown.addToCart", this.catchEnter.bind(this));

				this.$qtyField.on("keyup.addToCart", this.onQtyInput.bind(this));
				this.$qtyField.on("blur.addToCart", this.onAddQtyExit.bind(this));
			}
		}
	}, {
		key: "unwatch",
		value: function unwatch() {
			this.$element.off(".addToCart");
			this.$addToCartButton.off(".addToCart");
			this.$qtyField.off(".addToCart");

			log("unbound", this.$element);
		}
	}, {
		key: "onSuccess",
		value: function onSuccess(result) {
			this.$addToCartButton.removeClass(PROGRESS_CLASS).removeAttr("disabled");

			if (typeof result.Success !== "undefined" && result.Success) {
				if (typeof result.ItemsInCart !== "undefined") {
					if (this.$headerCartLink.find(".count").length == 0) {
						this.$headerCartLink.append('<span class="count">' + result.ItemsInCart + "</span>");
					} else {
						this.$headerCartLink.find(".count").html(result.ItemsInCart);
					}

					this.resetForm(result.ItemsInCart);

					this.updateEventTarget.dispatchEvent(new CustomEvent("updateCart", {
						bubbles: false,
						detail: {
							count: result.ItemsInCart
						}
					}));

					this.$addToCartButton.addClass(SUCCESS_CLASS);
					this.submitFadeTimeout = setTimeout(function ($addToCartButton) {
						$addToCartButton.removeClass(SUCCESS_CLASS);
					}, 8000, this.$addToCartButton);
				}
				if (result.ItemAddedDatalayer) {
					var filteredData = _gaServices.GAServices.filterEmptyData(result.ItemAddedDatalayer);
					var dataTracking = {
						event: 'add_to_cart',
						ecommerce: {
							currency: $('body').data('currency'),
							value: '',
							items: []
						}
					};
					filteredData.quantity = this.quantity;
					dataTracking.ecommerce.value = (filteredData.price * this.quantity).toFixed(2);
					dataTracking.ecommerce.items.push(filteredData);
					_gaServices.GAServices.trackingGA(dataTracking);
				}
				if (result.KlaviyoItemAddedDatalayer && !!result.KlaviyoCarts) {
					var kFilteredData = _klaviyoServices.KlaviyoServices.filterEmptyData(result.KlaviyoItemAddedDatalayer);
					var kDataTracking = {
						type: 'Add',
						currency: $('body').data('currency'),
						market_code: $('body').data('market-code'),
						quantity: this.quantity,
						value: kFilteredData.price * this.quantity,
						total_cart_value: _klaviyoServices.KlaviyoServices.getTotalCartValue(result.KlaviyoCarts),
						product: kFilteredData,
						items: _klaviyoServices.KlaviyoServices.sortProductsByQuantity(result.KlaviyoCarts),
						total_quantity: _klaviyoServices.KlaviyoServices.getTotalQuantity(result.KlaviyoCarts)
					};

					_klaviyoServices.KlaviyoServices.trackingKlaviyo('Added To Cart', kDataTracking);
				}
			} else {
				var errorList = typeof result.ValidationMessages !== "undefined" ? result.ValidationMessages : Array();
				log("addToCartServerError", errorList);
				this.handleErrors(errorList, "server");
			}
		}
	}, {
		key: "handleErrors",
		value: function handleErrors(errorList, errorSource) {
			var errorMessage = errorList.join(" ");
			var submitErrorClass = errorSource == "submit" ? this.options.submitErrorClassname : "";
			if (this.$errorElement.length > 0) {
				this.$errorElement.show().find(ERROR_CONTAINER_SELECTOR).empty().append(errorMessage);
				this.$errorElement.removeClass(HIDE_CLASS);
				var mod = this;
				setTimeout(function () {
					mod.$errorElement.fadeOut();
				}, 6000);
			}

			this.$qtyField.addClass(this.errorClassname + " " + submitErrorClass);
		}
	}, {
		key: "clearErrors",
		value: function clearErrors() {
			this.$qtyField.removeClass(this.errorClassname + " " + this.options.submitErrorClassname);
			this.$errorElement.addClass(HIDE_CLASS);
		}
	}, {
		key: "resetForm",
		value: function resetForm() {
			this.$qtyField.val(this.options.qty).trigger("keyup");

			// Possibly errors from server (even without quantity field)
			this.clearErrors();
		}
	}, {
		key: "getDatalayer",
		value: function getDatalayer() {
			var product = {};
			var component = this.options.component;
			if (component === 'PDP') {
				product = window.datalayerDataSource;
				product.quantity = $('[data-input-qty]').val();
				var dataItemList = _gaServices.GAServices.getItemListName(product.item_id);
				product = Object.assign({}, product, dataItemList);
			} else {
				var item = this.element.closest('[ga-tracking-item]');
				if (component === 'Reorder') {
					item = this.element;
				}
				product = _gaServices.GAServices.getAttributesWithPrefix($(item), 'ga-');
				product.quantity = 1;
			}
			var datalayer = [];
			if (Object.keys(product).length) {
				this.quantity = parseInt(product.quantity);
				_gaServices.GAServices.saveListItemsName(product);
				var saved = ['index', 'item_list_name', 'list_category', 'list_category2', 'list_category3'];
				datalayer = Object.fromEntries(Object.entries(product).filter(function (_ref) {
					var _ref2 = _slicedToArray(_ref, 1),
					    key = _ref2[0];

					return saved.includes(key);
				}));
			}

			return datalayer;
		}
	}, {
		key: "post",
		value: function post() {
			var _this = this;

			// GET QTY - entered valid input value or options value
			var datalayer = this.getDatalayer();
			var url = this.options.endpointUrl + "&" + this.options.codeParam + "=" + this.codeVal + "&" + this.options.qtyParam + "=" + this.getQty();
			if (Object.keys(datalayer).length) {
				var datalayerQuery = Object.entries(datalayer).map(function (_ref3) {
					var _ref4 = _slicedToArray(_ref3, 2),
					    key = _ref4[0],
					    value = _ref4[1];

					return encodeURIComponent(key) + "=" + encodeURIComponent(value);
				}).join("&");
				url = url + "&" + datalayerQuery;
			}

			var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

			log("accepting", this.$element, url);
			var post = $.ajax({
				url: url,
				method: "post",
				contentType: 'application/json',
				data: JSON.stringify({
					__RequestVerificationToken: token
				}),
				success: function success(result) {
					_this.onSuccess(result);
				},
				error: function error(e) {
					log("addToCartAjaxError", e);
					_this.$addToCartButton.removeClass(PROGRESS_CLASS).removeAttr("disabled");
					_this.handleErrors([validationMessages.connection], "submit");
				}
			}).done(function () {
				log("accepted", _this.$element, url);
			});

			this.posts.push(post);
		}

		// called on external instance

	}, {
		key: "getPendingStatus",
		value: function getPendingStatus() {
			return Promise.all(this.posts);
		}
	}]);

	return AddToCartPlugin;
}();

AddToCartPlugin.DEFAULTS = {
	code: null,
	qty: "1",
	maxQty: 1000,
	qtyField: "",
	endpointUrl: $("meta[name=\"site.addToCartApiEndpoint\"]").attr("content"),
	codeParam: "code",
	qtyParam: "qty",
	cartLink: "[data-cart-link]",
	submitButton: '[type="submit"]',
	notificationElementSelector: "[data-add-to-cart-notification]",
	errorElement: "[data-add-to-cart-error]",
	errorClassname: "error",
	submitErrorClassname: "submit-error",
	productElementSelector: ".product-teaser",
	cartSelector: "[data-update-cart]"
};

(0, _plugin2.default)("addToCart", AddToCartPlugin);

function exec() {
	$(function () {
		log("binding");
		$(ELEMENT_SELECTOR).addToCart();

		$(document).on('product-teasers-loaded', function () {
			$(ELEMENT_SELECTOR).addToCart();
		});
		log("bound");
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\address-autocomplete\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _googleMapsApi = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\index.js");

var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-address-autocomplete]";
var STATE_ELEMENT_ATTR = "data-address-autocomplete-state-field";
var SUBURB_ELEMENT_ATTR = "data-address-autocomplete-suburb-field";
var POSTCODE_ELEMENT_ATTR = "data-address-autocomplete-postcode-field";
var COUNTRY_ELEMENT_ATTR = "data-address-autocomplete-country-field";
var ADDRESS_LINE_0_ELEMENT_ATTR = "data-address-autocomplete-line0-field";
var ADDRESS_LINE_1_ELEMENT_ATTR = "data-address-autocomplete-line1-field";
var RESTRICT_TO_COUNTRY_ELEMENT_ATTR = "data-address-autocomplete-restrict-to-country-field";

var PLUGIN_NAME = "addressAutocomplete";
var MODULE_NAME = "app.core/modules/address-autocomplete";
var log = (0, _debug2.default)(MODULE_NAME);

log("registerd");

var AddressAutocomplete = function () {
	function AddressAutocomplete(element, options) {
		var _this = this;

		_classCallCheck(this, AddressAutocomplete);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$addressLine0 = $(this.$element.attr(ADDRESS_LINE_0_ELEMENT_ATTR));
		this.$addressLine1 = $(this.$element.attr(ADDRESS_LINE_1_ELEMENT_ATTR));
		this.$suburbField = $(this.$element.attr(SUBURB_ELEMENT_ATTR));
		this.$stateField = $(this.$element.attr(STATE_ELEMENT_ATTR));
		this.$postcodeField = $(this.$element.attr(POSTCODE_ELEMENT_ATTR));
		this.$countryField = $(this.$element.attr(COUNTRY_ELEMENT_ATTR));
		this.countryCode = this.$element.attr(RESTRICT_TO_COUNTRY_ELEMENT_ATTR);

		log("construct", element);
		this.preventSubmit();

		_googleMapsApi2.default.then(function (google) {
			_this.google = google;
		}).then(this.init.bind(this));
	}

	_createClass(AddressAutocomplete, [{
		key: "loadAutoCompleteAPI",
		value: function loadAutoCompleteAPI(params) {
			var script = document.createElement("script");

			script.type = "text/javascript";

			script.src = urlBuilder({
				base: "https://maps.googleapis.com/maps/api/js",
				libraries: params.libraries || [],
				callback: "googleMapsAutoCompleteAPILoad",
				apiKey: params.apiKey,
				client: params.client
			});

			document.querySelector("head").appendChild(script);
		}
	}, {
		key: "preventSubmit",
		value: function preventSubmit() {
			if (this.$element.closest("form").length) {
				log("preventSubmit.enabled [Preventing form submission on ENTER press.]");

				this.$element.on("keypress", function (event) {
					if (event.keyCode === 13) {
						event.preventDefault();
						log("preventSubmit.keypress", event.keyCode);
					}
				});
			}
		}
	}, {
		key: "init",
		value: function init() {
			var options = {};

			if (typeof this.countryCode !== "undefined" && this.countryCode.length > 0) {
				options["componentRestrictions"] = { country: this.countryCode };
			}

			var el = this.$element.attr("id");

			// Google global
			window.gm_authFailure = this.handleGoogleAuthFailure.bind(this);

			var autocomplete = new this.google.maps.places.Autocomplete(document.getElementById(el), options);
			autocomplete.setFields(["formatted_address", "geometry", "address_component"]);

			this.autocomplete = autocomplete;
			this.changeListener = autocomplete.addListener("place_changed", this.fillInAddress.bind(this));
			log("init");
		}
	}, {
		key: "handleGoogleAuthFailure",
		value: function handleGoogleAuthFailure() {
			google.maps.event.clearInstanceListeners(this.element);
			this.element.removeAttribute("disabled");
			this.element.removeAttribute("autocomplete");
			this.element.classList.remove("pac-target-input");
			this.element.classList.remove("gm-err-autocomplete");
			this.element.style = "";
			this.element.placeholder = "";
		}
	}, {
		key: "triggerInput",
		value: function triggerInput(element) {
			element.dispatchEvent(new Event("input"));
		}
	}, {
		key: "fillInAddress",
		value: function fillInAddress() {
			var place = this.autocomplete.getPlace();
			var elementVal = this.$element.val();
			log("fillInAddress", place);
			this.$element.trigger({ type: "place_selected", place: place });

			if (typeof this.$addressLine0 !== "undefined" && this.$addressLine0.length > 0) {
				this.$addressLine0.val("");
				this.$addressLine0.attr("disabled", false);
			}
			if (typeof this.$suburbField !== "undefined" && this.$suburbField.length > 0) {
				this.$suburbField.val("");
				this.$suburbField.attr("disabled", false);
			}
			if (typeof this.$stateField !== "undefined" && this.$stateField.length > 0) {
				this.$stateField.val("");
				this.$stateField.attr("disabled", false);
			}
			if (typeof this.$postcodeField !== "undefined" && this.$postcodeField.length > 0) {
				this.$postcodeField.val("");
				this.$postcodeField.attr("disabled", false);
			}
			if (typeof this.$countryField !== "undefined" && this.$countryField.length > 0) {
				this.$countryField.val("");
				this.$countryField.attr("disabled", false);
			}

			var addressLine0 = "";
			var addressLine1 = "";
			var premise = "";
			var subpremise = "";
			var route = "";
			var postBox = "";
			var postalTown = "";
			var administrative_area_level_1 = "";
			var administrative_area_level_2 = "";
			var locality = "";
			var postcode = "";
			var countryCode = "";

			for (var i = 0; i < place.address_components.length; i++) {
				var addressType = place.address_components[i].types[0];

				if (addressType == "post_box") {
					postBox = place.address_components[i][this.options.componentForm["post_box"]];
				}
				if (addressType == "premise") {
					premise = place.address_components[i][this.options.componentForm["premise"]];
				}
				if (addressType == "subpremise") {
					subpremise = place.address_components[i][this.options.componentForm["subpremise"]];
				}
				if (addressType == "street_number") {
					addressLine1 = addressLine1.length == 0 ? place.address_components[i][this.options.componentForm["street_number"]] : addressLine1;
				}
				if (addressType == "route") {
					route = place.address_components[i][this.options.componentForm["route"]];

					// Retain unit numbers entered in form.
					var regex = RegExp("^(.*)" + route.split(" ", 1)[0]),
					    result = regex.exec(elementVal);

					if (Array.isArray(result)) {
						addressLine1 = result[1];
					}
				}
				if (addressType == "postal_town") {
					postalTown = place.address_components[i][this.options.componentForm["postal_town"]];
				}
				if (addressType == "locality" || addressType == "colloquial_area") {
					locality = place.address_components[i][this.options.componentForm["locality"]];
				}
				if (addressType == "administrative_area_level_2") {
					administrative_area_level_2 = place.address_components[i][this.options.componentForm["administrative_area_level_2"]];
				}

				if (addressType == "administrative_area_level_1") {
					administrative_area_level_1 = place.address_components[i][this.options.componentForm["administrative_area_level_1"]];
				}

				if (addressType == "postal_code") {
					postcode = place.address_components[i][this.options.componentForm["postal_code"]];
				}

				if (addressType == "country") {
					countryCode = place.address_components[i][this.options.componentForm["country"]];
				}
			}

			if (locality.length == 0) {
				locality = postalTown;
			}
			if (locality.length == 0) {
				locality = administrative_area_level_2;
			}

			var add0 = subpremise.length > 0 ? subpremise + " " : "";
			add0 = add0.length > 0 ? add0 : addressLine0;
			add0.trim();

			var add1 = postBox.length > 0 ? "PO BOX " + postBox + " " : "";
			add1 += premise.length > 0 ? premise + " " : "";
			add1 += addressLine1.length > 0 ? addressLine1 + " " : "";
			add1 += route;
			add1.trim();

			if (this.countryCode === 'USA') {
				this.$element.val([add1, add0].join(' '));
			} else {
				this.$element.val(add1);
			}

			if (typeof this.$addressLine0 !== "undefined" && this.$addressLine0.length > 0) {
				this.$addressLine0.val(add0);
				this.triggerInput(this.$addressLine0[0]);
			}

			if (typeof this.$addressLine1 !== "undefined" && this.$addressLine0.length > 0) {
				this.$addressLine1.val(add1);
				this.triggerInput(this.$addressLine1[0]);
			}

			if (typeof this.$suburbField !== "undefined") {
				this.$suburbField.val(locality);
				this.triggerInput(this.$suburbField[0]);
			}

			if (typeof this.$stateField !== "undefined") {
				this.$stateField.val(administrative_area_level_1);
				this.triggerInput(this.$stateField[0]);
			}

			if (typeof this.$postcodeField !== "undefined") {
				this.$postcodeField.val(postcode);
				this.triggerInput(this.$postcodeField[0]);
			}

			if (typeof this.$countryField !== "undefined") {
				this.$countryField.val(countryCode);
			}

			$(document).trigger("address-validation-complete");
		}
	}]);

	return AddressAutocomplete;
}();

AddressAutocomplete.DEFAULTS = {
	componentForm: {
		post_box: "long_name",
		premise: "long_name",
		subpremise: "long_name",
		street_number: "short_name",
		sublocality_level_1: "short_name",
		route: "long_name",
		locality: "long_name",
		administrative_area_level_1: "short_name",
		administrative_area_level_2: "short_name",
		country: "short_name",
		postal_code: "short_name",
		postal_town: "short_name"
	}
};

(0, _plugin2.default)(PLUGIN_NAME, AddressAutocomplete);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\afterpay-payment\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-afterpay-payment]'; // load this module if present in DOM

var PLUGIN_NAME = 'afterpayPayment';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("afterpay-payment").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\afterpay-payment\\afterpay-payment.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\ajax-submit\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-ajax-submit]';
var PLUGIN_NAME = 'ajaxSubmit';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("ajax-submit").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\ajax-submit\\ajax-submit.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\alert-bar\\dismiss.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dismiss
 * Alerts
 * @author Oliver Boermans
 */

var log = (0, _debug2.default)("alerts");

//
// Config
// ===========
var ALERT_SELECTOR = "[data-alert]";
var ALERT_BUTTON_SELECTOR = 'button';

var hidePanel = function hidePanel(alertToHide) {
	(0, _jquery2.default)(alertToHide).hide();
	(0, _jquery2.default)('body').removeClass('has-alert');
};

var dismissAlert = function dismissAlert(instance) {
	var element = instance.element,
	    alertApi = instance.alertApi,
	    alertId = instance.alertId;

	_jquery2.default.get(alertApi, {
		id: alertId
	});
	hidePanel(element);
};

function init() {
	var alertElements = (0, _jquery2.default)(ALERT_SELECTOR);
	log(alertElements);
	alertElements.each(function (index, element) {
		var alertApi = element.dataset.alertApi;
		var alertId = element.id;
		var alertButton = (0, _jquery2.default)(element).find(ALERT_BUTTON_SELECTOR);

		if (alertButton.length) {
			alertButton.on('click', dismissAlert.bind(null, { element: element, alertApi: alertApi, alertId: alertId }));
		} else {
			log("No site alert button found.");
		}
	});
};

init();

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\alert-bar\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\alert-bar\\dismiss.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\analytics-trigger\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="radio"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-event-name="checkboxClicked"
 *        data-analytics-trigger-some-value="foo"
 *        data-analytics-trigger-some-other-value="bar"
 *        data-analytics-trigger-yet-another-value="baz">
 *
 *    <input
 *        type="search"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-extract-value-as="searchTerm"
 *        data-analytics-trigger-event-name="checkboxClicked">
 */

exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-analytics-trigger]';
var MODULE_NAME = 'app.core/modules/analytics-trigger';
var log = (0, _debug2.default)(MODULE_NAME);
var ZERO = 0;

var AnalyticsTriggerPlugin = function () {
    function AnalyticsTriggerPlugin(element, options) {
        _classCallCheck(this, AnalyticsTriggerPlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.watching = null;
        this.$nodeType = this.$element.get(ZERO).nodeType;
        this.isFormField = ['input', 'textarea', 'select', 'button'].includes(this.$nodeType);
        log('AnalyticsTriggerPlugin', element);

        this.watch();
        log('ready', this.$element);
    }

    _createClass(AnalyticsTriggerPlugin, [{
        key: 'watch',
        value: function watch() {
            this.watching = this.$element.on(this.options.on, this.trigger.bind(this));
            log('watching', this.$element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off(this.watching);
            log('unwatched', this.$element);
        }
    }, {
        key: 'trigger',
        value: function trigger() {
            var _this = this;

            log('trigger');
            var data = Object.keys(this.options).filter(function (key) {
                return !['on', 'extractValueAs'].includes(key);
            }).reduce(function (result, key) {
                result[key] = _this.options[key];

                return result;
            }, {});

            if (this.isFormField && this.options.extractValueAs) {
                data[this.options.extractValueAs] = this.$element.val();
            }

            log('trigger.data ' + JSON.stringify({ data: data }));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(data);
            }
        }
    }]);

    return AnalyticsTriggerPlugin;
}();

AnalyticsTriggerPlugin.DEFAULTS = {
    on: "click",
    event: null,
    extractValueAs: null
};

(0, _plugin2.default)('analyticsTrigger', AnalyticsTriggerPlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).analyticsTrigger();
        log('bound');
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\anchor-tabs\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ELEMENT_SELECTOR = '[data-anchor-tabs]';
var elements = Array.from(document.querySelectorAll(ELEMENT_SELECTOR));

if (elements.length) {
	__webpack_require__.e/* import() */("anchor-tabs").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\anchor-tabs\\anchor-tabs.js")).then(function (module) {
		module.default(elements);
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\applepay-payment\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-apple-payment]'; // load this module if present in DOM

var PLUGIN_NAME = 'applePayment';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("applepay-payment").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\applepay-payment\\applepay-payment.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\button-count\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-button-count]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'ButtonCount';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("button-count").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\button-count\\button-count.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\button-pending-state\\button-pending-state.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("button-pending-state");

var ButtonPendingState = function () {
	function ButtonPendingState(element, options) {
		_classCallCheck(this, ButtonPendingState);

		this.element = element;
		this.options = options;

		log(element, options);

		this.button = element.closest("button");
		this.controller = this.options.controllerSelector ? document.querySelector(this.options.controllerSelector) : document;

		if (!this.button) {
			log("Parent button not found. Aborting...");
			return false;
		}

		if (this.options.controllerSelector && !this.controller) {
			log("Controller element matching \"" + this.options.controllerSelector + "\" not found. Aborting...");
			return false;
		}

		this.watch();
	}

	_createClass(ButtonPendingState, [{
		key: "watch",
		value: function watch() {
			this.controller.addEventListener(this.options.enterEvent, this.disableButton.bind(this));
			this.controller.addEventListener(this.options.exitEvent, this.reEnableButton.bind(this));
		}
	}, {
		key: "disableButton",
		value: function disableButton() {
			this.button.classList.add(this.options.pendingClass);
			this.button.addEventListener("click", this.handleDisabledClick.bind(this), { capture: true });
		}
	}, {
		key: "reEnableButton",
		value: function reEnableButton() {
			this.button.classList.remove(this.options.pendingClass);
			this.button.removeEventListener("click", this.handleDisabledClick.bind(this), { capture: true });
		}
	}, {
		key: "handleDisabledClick",
		value: function handleDisabledClick(event) {
			event.preventDefault();
			event.stopImmediatePropagation();
		}
	}]);

	return ButtonPendingState;
}();

ButtonPendingState.DEFAULTS = {
	pendingClass: "is--pending"
};

exports.default = ButtonPendingState;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\button-pending-state\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _buttonPendingState = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\button-pending-state\\button-pending-state.js");

var _buttonPendingState2 = _interopRequireDefault(_buttonPendingState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-button-pending-state]';
var PLUGIN_NAME = 'ButtonPendingState';
var elements = document.querySelectorAll(ELEMENT_SELECTOR);

if (elements.length) {
	(0, _lib2.default)(PLUGIN_NAME, _buttonPendingState2.default);
	$(elements)[PLUGIN_NAME]();
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-check\\cart-check.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = requestCount;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)("cart-check");

function getRequestToken() {
	var requestTokenInputSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]';

	var input = document.querySelector(requestTokenInputSelector);

	if (!input || !input.value) {
		log("Error: Missing __RequestVerificationToken. Aborting");
		return false;
	}
	return input.value;
}

function requestCount(endpoint) {
	log("Requesting count from " + endpoint);
	var requestToken = getRequestToken();

	if (!endpoint) {
		return Promise.reject("Error: Missing endpoint arg");
	}

	if (!requestToken) {
		return Promise.reject("Error: Missing __RequestVerificationToken. Aborting");
	}

	return fetch(endpoint, {
		method: "POST",
		body: JSON.stringify({
			__RequestVerificationToken: requestToken
		}),
		headers: {
			"Content-Type": "application/json"
		}
	}).then(function (response) {
		if (response.ok) {
			return response.json();
		}
		return Promise.reject(response);
	}).then(function (count) {
		log("Count", count);
		return count;
	}).catch(function (error) {
		log("error", error);
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-count\\cart-count.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("cart-count");

var CartCount = function () {
	function CartCount(element, options) {
		_classCallCheck(this, CartCount);

		this.element = element;
		this.options = options;

		this.cartLinks = [].concat(_toConsumableArray(document.querySelectorAll(this.options.linkSelector)));

		if (!this.cartLinks.length) {
			log("Missing cart link element\ndata-cart-count-link-selector=\"" + this.options.cartLinkSelector + "\" Aborting");
			return false;
		}

		this.requestTokenInput = document.querySelector(this.options.requestTokenInputSelector);

		if (!this.requestTokenInput || !this.requestTokenInput.value) {
			log("Error: Missing __RequestVerificationToken. Aborting");
			return false;
		}

		this.listenerTarget = this.options.listenerTarget ? this.options.listenerTarget === "window" ? window : document.querySelector(this.options.listenerTarget) : this.element;

		if (!this.listenerTarget) {
			log("Error: listenerTarget not found\ndata-cart-count-listener-target=\"" + this.options.listenerTarget + "\" Aborting");
			return false;
		}

		this.init();
	}

	_createClass(CartCount, [{
		key: "init",
		value: function init() {
			this.requestCount();
			this.watch();
		}
	}, {
		key: "watch",
		value: function watch() {
			log(this.element, this.options);

			this.listenerTarget.addEventListener(this.options.updateOn, this.requestCount.bind(this));
		}
	}, {
		key: "getRequestToken",
		value: function getRequestToken() {
			return this.requestTokenInput.value;
		}
	}, {
		key: "updateCartLinkCounts",
		value: function updateCartLinkCounts(count) {
			var _this = this;

			this.cartLinks.forEach(function (link) {
				var countElement = link.querySelector(".count") || _this.makeCountElement(link);
				if (count) {
					countElement.textContent = count;
				} else {
					countElement.remove();
				}
			});
		}
	}, {
		key: "makeCountElement",
		value: function makeCountElement(link) {
			var span = document.createElement("span");
			span.classList.add("count");
			link.append(span);
			return span;
		}
	}, {
		key: "requestCount",
		value: function requestCount() {
			var _this2 = this;

			log("Requesting count");

			this.updateCartLinkCounts("…");

			fetch(this.options.endpoint, {
				method: "POST",
				body: JSON.stringify({
					__RequestVerificationToken: this.getRequestToken()
				}),
				headers: {
					"Content-Type": "application/json"
				}
			}).then(function (response) {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			}).then(function (count) {
				log("Count", count);
				_this2.updateCartLinkCounts(count);
			}).catch(function (error) {
				log("error", error);
			});
		}
	}]);

	return CartCount;
}();

CartCount.DEFAULTS = {
	requestTokenInputSelector: '#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]'
};

exports.default = CartCount;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-count\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _cartCount = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-count\\cart-count.js");

var _cartCount2 = _interopRequireDefault(_cartCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-cart-count]';
var PLUGIN_NAME = 'CartCount';

(0, _lib2.default)(PLUGIN_NAME, _cartCount2.default);

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-count\\cart-count.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-delivery-page\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-cart-delivery-page]';
var PLUGIN_NAME = 'CartDeliveryPage';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--cart-delivery-page").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-delivery-page\\cart-delivery-page.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-notification\\cart-notification.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("cart-notification");

var CartNotification = function () {
	function CartNotification(element, options) {
		_classCallCheck(this, CartNotification);

		this.element = element;
		this.options = options;
		this.cartCountElement = element.querySelector(this.options.cartCountElementSelector);
		this.isOpened = false;

		log(this);
		this.watch();
	}

	_createClass(CartNotification, [{
		key: "watch",
		value: function watch() {
			this.element.addEventListener("updateCart", this.onUpdate.bind(this));
			this.element.addEventListener("transitionend", this.transitionHandler.bind(this));

			document.addEventListener("click", this.documentClickHandler.bind(this));
		}
	}, {
		key: "onUpdate",
		value: function onUpdate(event) {
			this.updateCartCount(event.detail.count);
			if (!this.isOpened) {
				this.preFadeIn();
			}
		}
	}, {
		key: "updateCartCount",
		value: function updateCartCount(count) {
			var itemPluralised = count === 1 ? "item" : "items";
			this.cartCountElement.textContent = count + " " + itemPluralised;
		}
	}, {
		key: "nextAnimationFrame",
		value: function nextAnimationFrame(func) {
			window.requestAnimationFrame(function () {
				window.requestAnimationFrame(func);
			});
		}
	}, {
		key: "preFadeIn",
		value: function preFadeIn() {
			this.isOpened = true;
			this.element.hidden = false;
			this.element.classList.add(this.options.transparentClass);

			// Cancel any pre-existing timer
			window.clearTimeout(this.closeTimer);

			this.closeTimer = setTimeout(function (callback) {
				callback();
			}, this.options.openDuration, this.fadeOut.bind(this));

			this.nextAnimationFrame(this.fadeIn.bind(this));
		}
	}, {
		key: "fadeIn",
		value: function fadeIn() {
			this.element.classList.add(this.options.fadeInClass);
		}
	}, {
		key: "fadeOut",
		value: function fadeOut() {
			this.isOpened = false;
			this.element.classList.add(this.options.transparentClass);
		}
	}, {
		key: "hide",
		value: function hide() {
			this.isOpened = false;
			this.element.hidden = true;
			this.element.classList.remove(this.options.transparentClass);

			document.removeEventListener("click", this.documentClickHandler.bind(this));
		}
	}, {
		key: "transitionHandler",
		value: function transitionHandler(event) {
			var element = this.element;

			if (event.target !== element) {
				return false;
			}

			if (this.isOpened) {
				log('opened');
				this.element.classList.remove(this.options.transparentClass);
				this.element.classList.remove(this.options.fadeInClass);
			} else {
				log('closed');
				this.hide();
			}
		}
	}, {
		key: "documentClickHandler",
		value: function documentClickHandler(event) {
			this.hide();
		}
	}]);

	return CartNotification;
}();

CartNotification.DEFAULTS = {
	transparentClass: "cart-notification--transparent",
	fadeInClass: "cart-notification--fade-in",
	cartCountElementSelector: "[data-items-in-cart]",
	openDuration: 6000
};

exports.default = CartNotification;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-notification\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _cartNotification = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-notification\\cart-notification.js");

var _cartNotification2 = _interopRequireDefault(_cartNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-add-to-cart-notification]';
var PLUGIN_NAME = 'CartNotification';

(0, _lib2.default)(PLUGIN_NAME, _cartNotification2.default);

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-quantity\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-cart-quantity]';
var PLUGIN_NAME = 'CartQuantity';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--cart-quantity").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-quantity\\cart-quantity.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-summary\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-cart-summary]';
var PLUGIN_NAME = 'CartSummary';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--cart-summary").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-summary\\cart-summary.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\checkbox-set\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-checkbox-set]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'CheckboxSet';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("checkbox-set").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\checkbox-set\\checkbox-set.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\click-tracking\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-click-tracking]';
var TRACK_ID_ATTR = 'data-click-tracking-trackid';
var HIT_ID_ATTR = 'data-click-tracking-hitid';
var HIT_QUERY_ATTR = 'data-click-tracking-hitquery';
var PLUGIN_NAME = 'clickTracking';
var MODULE_NAME = 'app.core/modules/click-tracking';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var ClickTracking = function () {
	function ClickTracking(element, options) {
		_classCallCheck(this, ClickTracking);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.hitId = this.$element.attr(HIT_ID_ATTR);
		this.query = this.$element.attr(HIT_QUERY_ATTR);
		this.trackId = this.$element.attr(TRACK_ID_ATTR);
		log('construct', element);

		this.watch();
	}

	_createClass(ClickTracking, [{
		key: 'sendClickTrackingData',
		value: function sendClickTrackingData() {
			var _this = this;

			var url = this.options.url + '?' + this.options.endpointParam1 + '=' + this.hitId + '&' + this.options.endpointParam2 + '=' + this.query + '&' + this.options.endpointParam3 + '=' + this.trackId;
			$.ajax({
				url: url,
				method: 'get',
				success: function success(result) {},
				error: function error(e) {
					log('sendClickTrackingData', e);
				}
			}).done(function () {
				log('accepted', _this.$element, url);
			});
		}
	}, {
		key: 'watch',
		value: function watch() {
			var module = this;
			this.$element.on('click', function (e) {
				module.sendClickTrackingData();
			});
		}
	}]);

	return ClickTracking;
}();

ClickTracking.DEFAULTS = {
	url: $('meta[name="site.clickTrackingApiEndpoint"]').attr('content'),
	endpointParam1: 'hitId',
	endpointParam2: 'query',
	endpointParam3: 'trackId'
};

(0, _plugin2.default)(PLUGIN_NAME, ClickTracking);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\clone-dialog\\index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-clone-dialog]';
var PLUGIN_NAME = 'CloneDialog';
var elements = document.querySelectorAll(ELEMENT_SELECTOR);

if (elements.length) {
	__webpack_require__.e/* import() */("clone-dialog").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\clone-dialog\\clone-dialog.js")).then(function (module) {
		(0, _lib2.default)(PLUGIN_NAME, module.default);
		$(elements)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\colour-list\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-colour-list]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'ColourList';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("colour-list").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\colour-list\\colour-list.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\commerce-analytics-impression\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLUGIN_NAME = 'CommerceAnalyticsImpression';


var ELEMENT_SELECTOR = '[data-commerce-analytics-impression]';
var elements = document.querySelectorAll(ELEMENT_SELECTOR);

if (elements.length) {
	__webpack_require__.e/* import() */("commerce-analytics-impression").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\commerce-analytics-impression\\commerce-analytics-impression.js")).then(function (module) {
		(0, _lib2.default)(PLUGIN_NAME, module.default);
		(0, _jquery2.default)(elements)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\commerce-analytics-trigger\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
           data-commerce-analytics-trigger-on="click"
           data-commerce-analytics-trigger-groupname="products"
           data-commerce-analytics-trigger-event="productClick"
           data-commerce-analytics-trigger-action="click"
           data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
           data-commerce-analytics-trigger-id="C486S0054"
           data-commerce-analytics-trigger-brand="HCA"
           data-commerce-analytics-trigger-price="232.00"
           data-commerce-analytics-trigger-category="Carry Bags">
 *
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
           data-commerce-analytics-trigger-on="click"
           data-commerce-analytics-trigger-groupname="products"
           data-commerce-analytics-trigger-event="productClick"
           data-commerce-analytics-trigger-action="click"
           data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
           data-commerce-analytics-trigger-id="C486S0054"
           data-commerce-analytics-trigger-brand="HCA"
           data-commerce-analytics-trigger-price="232.00"
           data-commerce-analytics-trigger-category="Carry Bags"
           data-commerce-analytics-trigger-dynamic="quantity:#quantity:1">

    Dynamic Format
    1. Field Name
    2. Field selector
    3. Default value if selector value is empty (optional)
* @example
    data-commerce-analytics-trigger-dynamic="quantity:#quantity:1"
 */

exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-commerce-analytics-trigger]';
var MODULE_NAME = 'app.core/modules/commerce-analytics-trigger';
var log = (0, _debug2.default)(MODULE_NAME);
var ZERO = 0;

var CommerceAnalyticsTriggerPlugin = function () {
    function CommerceAnalyticsTriggerPlugin(element, options) {
        _classCallCheck(this, CommerceAnalyticsTriggerPlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.watching = null;
        this.$nodeType = this.$element.get(ZERO).nodeType;
        this.isFormField = ['input', 'textarea', 'select', 'button'].includes(this.$nodeType);
        log('CommerceAnalyticsTriggerPlugin', element);

        this.watch();
        log('ready', this.$element);
    }

    _createClass(CommerceAnalyticsTriggerPlugin, [{
        key: "watch",
        value: function watch() {
            this.watching = this.$element.on(this.options.on, this.trigger.bind(this));
            log('watching', this.$element);
        }
    }, {
        key: "unwatch",
        value: function unwatch() {
            this.$element.off(this.watching);
            log('unwatched', this.$element);
        }
    }, {
        key: "trigger",
        value: function trigger() {
            var _this = this;

            log('trigger');
            var dataSet = {
                'event': this.options.event,
                'ecommerce': {}
            };

            var groupname = {};
            dataSet.ecommerce[this.options.action] = groupname;
            dataSet.ecommerce[this.options.action][this.options.groupname] = Array();
            if (typeof this.options.actionField !== 'undefined' && this.options.actionField.length > 0) {
                dataSet.ecommerce[this.options.action][this.options.actionField] = {
                    'list': this.options.actionFieldList
                };
            }

            var data = Object.keys(this.options).filter(function (key) {
                return !['on', 'extractValueAs', 'event', 'actionField', 'actionFieldList', 'action', 'groupname'].includes(key);
            }).reduce(function (result, key) {
                if (key.length > 0) {
                    if (key == 'dynamic') {
                        var dynamicData = _this.options[key].split(':');
                        var fieldName = dynamicData.length > 0 ? dynamicData[0] : '';
                        var selector = dynamicData.length > 1 ? dynamicData[1] : '';
                        var defaultVal = dynamicData.length > 2 ? dynamicData[2] : '';

                        if (typeof $(selector) !== 'undefined') {
                            var selectedVal = $(selector).val();
                            result[fieldName] = typeof selectedVal !== 'undefined' && selectedVal.length > 0 ? selectedVal : defaultVal;
                        }
                    } else {
                        result[key] = _this.options[key];
                    }
                }
                return result;
            }, {});

            dataSet.ecommerce[this.options.action][this.options.groupname].push(data);
            log("trigger.data " + JSON.stringify({ dataSet: dataSet }));
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(dataSet);
            }
        }
    }]);

    return CommerceAnalyticsTriggerPlugin;
}();

CommerceAnalyticsTriggerPlugin.DEFAULTS = {
    on: "click",
    event: 'productClick',
    groupname: 'products',
    action: 'click'
};

(0, _lib2.default)('commerceAnalyticsTrigger', CommerceAnalyticsTriggerPlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).commerceAnalyticsTrigger();

        $(document).on('product-teasers-loaded', function () {
            $(ELEMENT_SELECTOR).commerceAnalyticsTrigger();
        });
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\disable-on-submit\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/disable-on-submit';
var log = (0, _debug2.default)(MODULE_NAME);

var ELEMENT_SELECTOR = '[data-disable-on-submit]';
var PROGRESS_CLASS = 'is-submitting';

var DisableOnSubmit = function () {
    function DisableOnSubmit(element, options) {
        _classCallCheck(this, DisableOnSubmit);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$submitButton = $('[type="submit"]', element);
        log('DisableOnSubmit', element, options);
        this.watch();
    }

    _createClass(DisableOnSubmit, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            var form = this.$element;
            this.$submitButton.attr('disabled', 'disabled').addClass(PROGRESS_CLASS);
        }
    }, {
        key: 'watch',
        value: function watch() {
            this.$element.on('submit.disableonsubmit', this.onSubmit.bind(this));
            log('bound', this.element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('.disableonsubmit');
            this.$submitButton.removeAttr('disabled').removeClass(PROGRESS_CLASS);
            log('unbound', this.element);
        }
    }]);

    return DisableOnSubmit;
}();

DisableOnSubmit.DEFAULTS = {};

(0, _plugin2.default)('disableOnSubmit', DisableOnSubmit);

function exec() {
    $(function () {
        log('binding');
        $(ELEMENT_SELECTOR).disableOnSubmit();
        log('bound');
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\dismiss\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/dismiss';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_ATTRIBUTE = 'data-dismiss';

var DismissPlugin = function () {
    function DismissPlugin(element, options) {
        _classCallCheck(this, DismissPlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.dismissTarget = this.$element.attr(ELEMENT_ATTRIBUTE);
        this.$dismissElement = $(this.dismissTarget);

        log('DismissPlugin', element);
        this.watch();
    }

    _createClass(DismissPlugin, [{
        key: 'onClick',
        value: function onClick() {
            log('clicked', this.$element);
            this.dismissTargetElement();
        }
    }, {
        key: 'watch',
        value: function watch() {
            this.$element.on('click', this.onClick.bind(this));
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('click', this.onClick);
            log('unbound', this.$element);
        }
    }, {
        key: 'dismissTargetElement',
        value: function dismissTargetElement() {
            this.$dismissElement.fadeOut();
        }
    }]);

    return DismissPlugin;
}();

DismissPlugin.DEFAULTS = {};

(0, _plugin2.default)('dismiss', DismissPlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $("[data-dismiss]").dismiss();
        log('bound');
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\fancy-selection\\fancy-selection--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-fancy-selection]';
var PLUGIN_NAME = 'FancySelection';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("fancy-selection").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\fancy-selection\\fancy-selection.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\fancy-selection\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\fancy-selection\\fancy-selection--split.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\filter-panel\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-filter-group]';
var PLUGIN_NAME = 'FilterPanel';

$(function () {
    $(ELEMENT_SELECTOR).each(function () {
        var element = this;
        __webpack_require__.e/* import() */("plugin--filter-panel").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\filter-panel\\filter-panel.js")).then(function (module) {
            (0, _lib2.default)(PLUGIN_NAME, module.default);
            $(element)[PLUGIN_NAME]();
        });
    });

    $(document).on('filter-groups-loaded', function () {
        $(ELEMENT_SELECTOR).each(function () {
            var element = this;
            __webpack_require__.e/* import() */("plugin--filter-panel").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\filter-panel\\filter-panel.js")).then(function (module) {
                (0, _lib2.default)(PLUGIN_NAME, module.default);
                $(element)[PLUGIN_NAME]();
            });
        });
    });
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\form-validation\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-validate-form]';
var PLUGIN_NAME = 'validateForm';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("validate-form").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\form-validation\\validate-form.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _productFilterGroups = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\product-filter-groups.js");

var _productFilterGroups2 = _interopRequireDefault(_productFilterGroups);

var _inputFile = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\input-file.js");

var _inputFile2 = _interopRequireDefault(_inputFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exec() {
    (0, _productFilterGroups2.default)();
    (0, _inputFile2.default)();
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\input-file.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	$(".field-input-file").each(function () {
		var $input = $(this),
		    $label = $input.next("label"),
		    labelVal = $label.html();

		$input.on("change", function (e) {
			var fileName = "";

			if (this.files && this.files.length > 1) fileName = (this.getAttribute("data-multiple-caption") || "").replace("{count}", this.files.length);else if (e.target.value) fileName = e.target.value.split("\\").pop();

			if (fileName) $label.find("span").html(fileName);else $label.html(labelVal);
		});

		// Firefox bug fix
		$input.on("focus", function () {
			$input.addClass("has-focus");
		}).on("blur", function () {
			$input.removeClass("has-focus");
		});
	});
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\input-qty\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-input-qty]';
var PLUGIN_NAME = 'InputQty';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--input-qty").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\input-qty\\input-qty.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\product-filter-groups.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $(document).ready(function () {
        var $selectField = $(SELECTOR);
        var $changeField = $(HIDDEN);

        setTimeout(function () {
            $(LOADINGPANEL).removeClass('active');
            $(CHANGEFILTERS).fadeIn();
        }, 200);

        log('binding data-set-current-filter-group to', $selectField);

        $selectField.on('change', function onChanged() {
            var $this = $(this);
            var selectFieldValue = $this.attr(ATTR);
            log($this, 'changed. updating current filter group');
            $changeField.val(selectFieldValue);
        });
    });
};

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/modules/forms/product-filter-groups'); /**
                                                                             * Product Filter Groups
                                                                             * @author Kate York
                                                                             */

// Utilities

var ATTR = 'data-set-current-filter-group';
var HIDDEN = '[name="CurrentFilterGroup"]';
var SELECTOR = '[' + ATTR + ']';
var CHANGEFILTERS = '.product__filter-item--checkbox,.product__filter-item--radio';
var LOADINGPANEL = '.filter-panel-loading';

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\ga-tracking-event\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = '[ga-tracking-event]';
var PLUGIN_NAME = 'GaTrackingEvent';

$(function () {
	$(ELEMENT_SELECTOR).each(function (event) {
		var element = this;
		__webpack_require__.e/* import() */("plugin--ga-tracking-event").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\ga-tracking-event\\ga-tracking-event.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hotjar\\hotjar-tracker.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.hj = window.hj || function () {
	(hj.q = hj.q || []).push(arguments);
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hotjar\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hotjar\\hotjar-tracker.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hover-label\\hover-label--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-hover-label]';
var PLUGIN_NAME = 'HoverLabel';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("hover-label").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hover-label\\hover-label.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hover-label\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hover-label\\hover-label--split.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _toggleClass = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\toggle-class\\index.js");

var toggleClass = _interopRequireWildcard(_toggleClass);

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\sliders\\index.js");

var _forms = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\index.js");

var forms = _interopRequireWildcard(_forms);

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\anchor-tabs\\plugin--split.js");

var _disableOnSubmit = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\disable-on-submit\\index.js");

var disableOnSubmit = _interopRequireWildcard(_disableOnSubmit);

var _addToCart = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\add-to-cart\\index.js");

var addToCart = _interopRequireWildcard(_addToCart);

var _analyticsTrigger = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\analytics-trigger\\index.js");

var analyticsTrigger = _interopRequireWildcard(_analyticsTrigger);

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\commerce-analytics-impression\\index.js");

var _dismiss = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\dismiss\\index.js");

var dismiss = _interopRequireWildcard(_dismiss);

var _clickTracking = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\click-tracking\\index.js");

var clickTracking = _interopRequireWildcard(_clickTracking);

var _lazyLoad = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\lazy-load\\index.js");

var lazyLoad = _interopRequireWildcard(_lazyLoad);

var _tabs = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\tabs\\index.js");

var tabs = _interopRequireWildcard(_tabs);

var _modaal = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal\\index.js");

var modaal = _interopRequireWildcard(_modaal);

var _swiper = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swiper\\index.js");

var swiper = _interopRequireWildcard(_swiper);

var _showOnChange = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\show-on-change\\index.js");

var showOnChange = _interopRequireWildcard(_showOnChange);

var _addressAutocomplete = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\address-autocomplete\\index.js");

var addressAutocomplete = _interopRequireWildcard(_addressAutocomplete);

var _windcaveIframeContainer = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\windcave-iframe-container\\index.js");

var windcave = _interopRequireWildcard(_windcaveIframeContainer);

var _commerceAnalyticsTrigger = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\commerce-analytics-trigger\\index.js");

var commerceAnalyticsTrigger = _interopRequireWildcard(_commerceAnalyticsTrigger);

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\sortable-products\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-summary\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-quantity\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\update-cart\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\button-count\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\checkbox-set\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\picture-fix\\plugin--available.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\filter-panel\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\product-listing-page\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\submits-on-changed\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search-filter-form\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-delivery-page\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-notification\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\site-header\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\alert-bar\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\password-toggle\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\form-validation\\plugin--available.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\ajax-submit\\plugin--available.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\video-block\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\pop-window\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\mirror-value\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-count\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\colour-list\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\fancy-selection\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\forms\\input-qty\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hover-label\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\mini-cart\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal-ajax\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\open-simple-modal\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\payment-form\\plugin--available.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\scroll-to-top\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\simple-modal\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-grid\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-row\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\wysiwyg\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\hotjar\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\zendesk\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\paypal-payment\\plugin--available.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\afterpay-payment\\plugin--available.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\applepay-payment\\plugin--available.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\clone-dialog\\index--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\commerce-analytics-impression\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\button-pending-state\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\ga-tracking-event\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\quick-order\\plugin--available.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/modules'; /**
                                       * Core Modules Index
                                       */

// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

// Export
function exec() {
	log('Running...');

	forms.exec();
	disableOnSubmit.exec();
	addToCart.exec();
	dismiss.exec();
	tabs.exec();
	swiper.exec();
	showOnChange.exec();
	addressAutocomplete.exec();
	clickTracking.exec();
	lazyLoad.exec();
	modaal.exec();
	windcave.exec();

	//  keep this last - triggers events consumed by customSelect
	toggleClass.exec();
	analyticsTrigger.exec();
	commerceAnalyticsTrigger.exec();
}

exports.default = {
	exec: exec
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\lazy-load\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */
// Modified from https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video


exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/lazy-load';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_SELECTOR = '[data-lazy-load]';
var LAZY_LOAD_SRC_ATTR = 'data-lazy-load-src';
var LAZY_LOAD_SRCSET_ATTR = 'data-lazy-load-srcset';
var LAZY_LOAD_BACKGROUND_ID_ATTR = 'data-lazy-load-block-id';
var SRC_ATTR = 'src';

var LazyLoad = function () {
	function LazyLoad(element, options) {
		_classCallCheck(this, LazyLoad);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.lazyLoadSrc = this.$element.attr(LAZY_LOAD_SRC_ATTR);
		this.lazyLoadSrcSet = this.$element.attr(LAZY_LOAD_SRCSET_ATTR);
		this.backgroundIdAttr = this.$element.attr(LAZY_LOAD_BACKGROUND_ID_ATTR);

		log('LazyLoad', element);
		this.init();
	}

	_createClass(LazyLoad, [{
		key: 'init',
		value: function init() {
			var module = this;
			if ("IntersectionObserver" in window) {
				this.lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							module.setImageSrc();
						}
					});
				});

				this.watch();
			} else {
				this.setImageSrc();
			}
		}
	}, {
		key: 'setImageSrc',
		value: function setImageSrc() {
			if (typeof this.lazyLoadSrc !== 'undefined') {
				this.element.src = this.lazyLoadSrc;
			}
			if (typeof this.lazyLoadSrcSet !== 'undefined') {
				this.element.srcset = this.lazyLoadSrcSet;
			}
			if (typeof this.lazyImageObserver !== 'undefined') {
				this.lazyImageObserver.unobserve(this.element);
			}
			if (typeof this.backgroundIdAttr !== 'undefined') {
				this.$element.attr('id', this.backgroundIdAttr);
			}
			this.$element.addClass('lazyloaded');
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.lazyImageObserver.observe(this.element);
		}
	}]);

	return LazyLoad;
}();

LazyLoad.DEFAULTS = {};

(0, _plugin2.default)('lazyLoad', LazyLoad);

function exec() {
	$(document).ready(function () {
		log('binding');
		$(ELEMENT_SELECTOR).lazyLoad();
		$(document).on('product-teasers-loaded', function () {
			$(ELEMENT_SELECTOR).lazyLoad();
		});
		log('bound');
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\mini-cart\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-mini-cart]';
var PLUGIN_NAME = 'MiniCart';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--mini-cart").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\mini-cart\\mini-cart.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\mirror-value\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-mirror-value]';
var PLUGIN_NAME = 'MirrorValue';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--mirror-value").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\mirror-value\\mirror-value.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal-ajax\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal-ajax\\modaal-ajax--split.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal-ajax\\modaal-ajax--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-modaal-ajax]';
var PLUGIN_NAME = 'ModaalAjax';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("modaal-ajax").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal-ajax\\modaal-ajax.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});

	$(document).on('product-teasers-loaded', function () {
		$(ELEMENT_SELECTOR).each(function () {
			var element = this;
			__webpack_require__.e/* import() */("modaal-ajax").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal-ajax\\modaal-ajax.js")).then(function (module) {
				(0, _lib2.default)(PLUGIN_NAME, module.default);
				$(element)[PLUGIN_NAME]();
			});
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

var _modaal = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal\\modaal.js");

var _modaal2 = _interopRequireDefault(_modaal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-open-modaal],[data-modaal-swiper],[data-opened-modaal]'; /* global $:true module:true */

var MODULE_NAME = 'core/modules/modaal';
var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		(0, _modaal2.default)();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\modaal\\modaal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    setupModaals();
};

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\vendor\\modaal\\modaal.min@0.4.4.js");

function setupModaals() {
    $('[data-modaal-swiper]').click(function (e) {
        e.preventDefault();
    });
    $('[data-modaal-swiper]').each(function () {
        var modaal = this;
        var id = $(modaal).attr('href');
        $(modaal).modaal({
            content_source: id,
            type: 'inline',
            animation: 'fade',
            custom_class: 'product-detail-image__modal',
            after_open: function after_open() {
                $(modaal).hide();
                $(window).trigger('reinit-swiper');
            },
            after_close: function after_close() {
                $(modaal).show();
                $(window).trigger('reinit-swiper');
            }
        });
    });

    $('[data-open-modaal]').each(function () {
        var $element = $(this);
        var source = $(this).attr('data-modaal-content-source');
        var animation = $(this).attr('data-modaal-animation');
        var customClass = $(this).attr('data-modaal-custom-class');
        var locked = typeof isLocked !== 'undefined' && isLocked.length > 0 ? isLocked == 'true' : false;
        var disableClose = typeof hideClose !== 'undefined' && hideClose.length > 0 ? hideClose == 'true' : false;
        $element.modaal({
            content_source: source,
            hide_close: disableClose,
            is_locked: locked,
            animation: animation,
            custom_class: customClass,
            after_open: function after_open(wrapper) {
                wrapper.one("click", "[data-delegated-close-modaal]", function () {
                    $element.modaal('close');
                    wrapper.off("click");
                });
            }
        });

        $(source).find('[data-modaal-close]').click(function () {
            $element.modaal('close');
        });
    });

    $('[data-opened-modaal]').each(function () {
        var animation = $(this).attr('data-modaal-animation');
        var source = $(this).attr('data-modaal-content-source');
        var customClass = $(this).attr('data-modaal-custom-class');
        var isLocked = $(this).attr('data-modaal-is-locked');
        var hideClose = $(this).attr('data-modaal-hide-close');
        var locked = typeof isLocked !== 'undefined' && isLocked.length > 0 ? isLocked == 'true' : false;
        var disableClose = typeof hideClose !== 'undefined' && hideClose.length > 0 ? hideClose == 'true' : false;

        $(this).modaal({
            animation: animation,
            hide_close: disableClose,
            is_locked: locked,
            content_source: source,
            custom_class: customClass
        });

        $(this).modaal('open');
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\open-simple-modal\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-open-simple-modal]';
var PLUGIN_NAME = 'OpenSimpleModal';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--open-simple-modal").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\open-simple-modal\\open-simple-modal.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\password-toggle\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-password-toggle]';
var PLUGIN_NAME = 'PasswordToggle';

$(document).ready(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--password-toggle").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\password-toggle\\password-toggle.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\payment-form\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-payment-form]';
var PLUGIN_NAME = 'paymentForm';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("payment-form").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\payment-form\\payment-form.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\paypal-payment\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-paypal-payment]'; // load this module if present in DOM

var PLUGIN_NAME = 'paypalPayment';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("paypal-payment").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\paypal-payment\\paypal-payment.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\picture-fix\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-picture-fix]';
var PLUGIN_NAME = 'pictureFix';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("picture-fix").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\picture-fix\\picture-fix.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\pop-window\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-pop-window]';
var PLUGIN_NAME = 'PopWindow';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("pop-window").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\pop-window\\pop-window.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\product-listing-page\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-product-listing-page]';
var PLUGIN_NAME = 'ProductListingPage';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--product-listing-page").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\product-listing-page\\product-listing-page.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\quick-order\\plugin--available.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[quick-order]';
var PLUGIN_NAME = 'QuickOrder';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--quick-order").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\quick-order\\quick-order.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\scroll-to-top\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\scroll-to-top\\scroll-to-top--split.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\scroll-to-top\\scroll-to-top--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '.scroll-to-top__button';
var PLUGIN_NAME = 'ScrollToTop';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("scroll-to-top").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\scroll-to-top\\scroll-to-top.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search-filter-form\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-search-filter-form]';
var PLUGIN_NAME = 'SearchFilterForm';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--search-filter-form").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search-filter-form\\search-filter-form.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search\\dropdown\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _searchDropdown = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search\\dropdown\\search-dropdown.js");

var _searchDropdown2 = _interopRequireDefault(_searchDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-search-dropdown]';
var PLUGIN_NAME = 'SearchDropdown';

(0, _lib2.default)(PLUGIN_NAME, _searchDropdown2.default);

(0, _jquery2.default)(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search\\dropdown\\search-dropdown.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _gaServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\ga-services.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import keystroke from './keystroke';

var PLUGIN_NAME = 'SearchDropdown';

var log = (0, _debug2.default)('search-dropdown');

var SearchDropdown = function () {
	function SearchDropdown(element, options) {
		_classCallCheck(this, SearchDropdown);

		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);
		this.queryList = [];

		this.options.typingDebounceMs = parseInt(this.options.typingDebounceMs);

		this.options.escapeKeyCodes = this.options.escapeKeyCodes.split(' ');

		this.hasFocus = false;
		this.focsusedElement = null;
		this.searchCancelled = false;

		this.searchField = this.selectors.selectTarget(this.options.searchInputSelector, this.$element);
		this.submitButton = this.selectors.selectTarget(this.options.searchSubmitSelector, this.$element);
		this.cancelButton = this.selectors.selectTarget(this.options.searchCancelSelector, this.$element);
		this.resultsContainer = this.selectors.selectTarget(this.options.resultsContainerSelector, this.$element);

		this.templateSource = this.selectors.selectTarget(this.options.dropdownTemplateSelector, this.$element);
		this.template = this.templateSource.text();

		// Slurp up template and stick it into data
		// Not sure what problem this solves
		// Commented out as it prevents multiple search instances from sharing the template
		// this.templateSource.data('original-content', this.template);
		// this.templateSource.empty();

		window.strings = this.strings;

		this.watch();

		log('ready', this.$target);
	}

	_createClass(SearchDropdown, [{
		key: 'watch',
		value: function watch() {
			var _this = this;

			var debounceImmediate = this.options.typingDebounceEdge === 'leading';
			this.searchField.on('keyup', this.fn.debounce(this.send.bind(this), this.options.typingDebounceMs, debounceImmediate));

			// Respond to clear search button click (IE/Edge)
			this.searchField.on('mouseup', function () {
				var input = _this.searchField;
				var oldValue = input.val();
				if (oldValue === '') {
					return false;
				}
				setTimeout(function () {
					var newValue = input.val();
					if (newValue === '') {
						_this.cancel();
					}
				}, 0);
			});

			(0, _jquery2.default)(document).on('click', function (event) {
				var hasTarget = _this.$element.has(event.target);
				if (hasTarget && hasTarget.length) {
					_this.open();
				} else {
					_this.close();
				}
			});

			this.cancelButton.on('click', function () {
				log('cancelClick');
				_this.cancel();
			});

			log('watching');
		}
	}, {
		key: 'addToQueryList',
		value: function addToQueryList(q, qid) {
			this.queryList.push({
				queryId: qid,
				query: q,
				ignore: false,
				hasFinsihed: false
			});
		}
	}, {
		key: 'removeFromQueryList',
		value: function removeFromQueryList(queryEl) {
			// just make sure it exists and has finished
			var foundIndex = this.queryList.indexOf(queryEl);
			if (foundIndex > -1 && queryEl.hasFinsihed == true) {
				this.queryList.splice(foundIndex, 1);
			}
		}
	}, {
		key: 'getQueryFromList',
		value: function getQueryFromList(qid) {
			return this.queryList.find(function (element) {
				return element.queryId == qid;
			});
		}
	}, {
		key: 'setIgnoreForPreviousQueries',
		value: function setIgnoreForPreviousQueries(baseQuery) {

			var indexOfCaseQuery = this.queryList.indexOf(baseQuery);

			for (var index = 0; index < indexOfCaseQuery; index++) {
				var element = this.queryList[index];
				element.ignore = true;
			}
		}
	}, {
		key: 'send',
		value: function send(event) {
			var _this2 = this;

			this.close();
			var query = this.searchField.val();
			var keyCode = event.keyCode;
			var _options = this.options,
			    ignoreKeyCodes = _options.ignoreKeyCodes,
			    escapeKeyCodes = _options.escapeKeyCodes,
			    minQueryLength = _options.minQueryLength,
			    errorClass = _options.errorClass,
			    sendingClass = _options.sendingClass,
			    openClass = _options.openClass,
			    url = _options.url,
			    startPageId = _options.startPageId,
			    language = _options.language;


			log('send', query);

			// var withinAllowedRange = (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90);

			if (query && query.length < minQueryLength) {
				this.$element.trigger(PLUGIN_NAME + '.notMinLength');

				log('minQueryLength', query.length);
				return;
			} else if (ignoreKeyCodes.includes('' + keyCode)) {
				this.$element.trigger(PLUGIN_NAME + '.keyIgnored', { keyCode: keyCode });

				log('key[' + event.keyCode + '] ignored since it\'s in options.ignoreKeyCodes[' + ignoreKeyCodes + ']');
				return;
			} else if (escapeKeyCodes.includes('' + event.keyCode)) {
				this.$element.trigger(PLUGIN_NAME + '.escape');
				this.close();
				return;
			} else if (query && query.length) {
				this.submitButton.addClass(this.options.buttonSubmittingClass);
				this.$element.trigger(PLUGIN_NAME + '.beforeSend');
				this.$element.addClass(sendingClass);
				this.$element.removeClass(errorClass);

				// add it to query list
				var queryId = (Date.now() + Math.random()).toString(36);
				this.addToQueryList(query, queryId);

				_jquery2.default.ajax({
					url: url,
					data: {
						q: query,
						startPageId: startPageId,
						language: language
					},
					success: function success(data, status, request) {
						log('success', data, status);

						var successQuery = _this2.getQueryFromList(queryId);
						successQuery.hasFinsihed = true;
						if (successQuery.ignore == true) {
							log('ignored success', data, status, successQuery);
						} else {
							_this2.$element.removeClass(errorClass);
							_this2.render(data);
							_this2.$element.addClass(openClass);
							_this2.$element.trigger(PLUGIN_NAME + '.rendered');
							_this2.setIgnoreForPreviousQueries(successQuery); // Set previous query results to be ignored if they show up later.
							_this2.removeFromQueryList(successQuery); // Finally remove query from list (don't want to overload the list)
						}
					},
					error: function error(data, status, request) {
						log('error', data, status);

						_this2.$element.removeClass(openClass);
						_this2.$element.addClass(errorClass);
						_this2.$element.trigger(PLUGIN_NAME + '.error', {
							data: data,
							status: status,
							request: request
						});
					},
					complete: function complete() {
						_this2.$element.removeClass(sendingClass);
						_this2.submitButton.removeClass(_this2.options.buttonSubmittingClass);
					}
				});
			} else {
				this.cancel();
			}

			this.$element.trigger(PLUGIN_NAME + '.afterSend');
		}
	}, {
		key: 'onFocusChanged',
		value: function onFocusChanged(event) {
			log('onFocusChanged', event);
			this.focusedElement = event.toElement;
			var hasFocus = this.$element.has(this.focusedElement);
			this.hasFocus = hasFocus && hasFocus.length > 0;

			logger.log('onFocusIn.hasFocus', this.hasFocus);

			if (!this.hasFocus) {
				this.fn.debounce(this.close.bind(this), 50);
			}
		}
	}, {
		key: 'render',
		value: function render(data) {
			log('render', data, this.template);
			var context = Object.keys(data).reduce(function (result, key) {
				var value = data[key];
				result[key] = value;
				if (Array.isArray(value)) {
					result[key + 'IsEmpty'] = value.length === 0;
				}
				return result;
			}, {});
			var html = this.strings.mustache(this.template, context);
			var dom = _gaServices.GAServices.addGAForSearchAutoComplete(html, context.Results);
			log('rendered', html);
			this.resultsContainer.html(dom);
		}
	}, {
		key: 'reset',
		value: function reset(event) {
			log('reset');
			this.submitButton.removeClass(this.options.buttonSubmittingClass);
			this.searchField.val('');
			this.searchField.EmitOnDirty('clean');
			this.resultsContainer.empty();
		}

		// Display suggestions

	}, {
		key: 'open',
		value: function open() {
			log('open');
			this.$element.addClass(this.options.openClass);
			this.$element.trigger(PLUGIN_NAME + '.open');
		}
	}, {
		key: 'close',
		value: function close() {
			log('close');
			this.$element.removeClass(this.options.hasErrorClass);
			this.$element.removeClass(this.options.sendingClass);
			this.$element.removeClass(this.options.openClass);
			this.$element.trigger(PLUGIN_NAME + '.closed');
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			log('cancel');
			this.searchCancelled = true;
			this.reset();
			this.close();
		}
	}]);

	return SearchDropdown;
}();

SearchDropdown.DEFAULTS = {
	minQueryLength: 3,
	ignoreKeyCodes: '9 16 17 18 33 34 35 36 37 38 39 40 44 91 92 93 224',
	escapeKeyCodes: '27',
	searchInputSelector: '(here) [data-search-dropdown__input-field]',
	searchCancelSelector: '(here) [data-search-dropdown__cancel-button]',
	searchSubmitSelector: '(here) [data-search-dropdown__submit-button]',
	dropdownTemplateSelector: '(here) #search-dropdown--template',
	resultsContainerSelector: '(here) [data-search-dropdown__result-container]',
	typingDebounceMs: 500,
	typingDebounceEdge: 'trailing',
	openClass: 'search-dropdown--is-open',
	sendingClass: 'search-dropdown--is-sending',
	errorClass: 'search-dropdown--error',
	buttonSubmittingClass: 'is-submitting',
	placement: 'bottom',
	placementTarget: '(self)'
};

exports.default = SearchDropdown;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\search\\dropdown\\index.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\show-on-change\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-show-on-change]';
var ATTR_ELEMENT_SELECTOR = 'data-show-on-change-element-to-show';
var ATTR_SHOW_IF_NOT_EMPTY = 'data-show-on-change-if-not-empty';
var PLUGIN_NAME = 'showOnChange';
var MODULE_NAME = 'app.core/modules/show-on-change';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var ShowOnChange = function () {
    function ShowOnChange(element, options) {
        _classCallCheck(this, ShowOnChange);

        log('new instance', element, options);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.elementToShow = this.$element.attr(ATTR_ELEMENT_SELECTOR);
        this.$elementToShow = $(this.elementToShow);
        this.showIfNotEmpty = this.element.hasAttribute(ATTR_SHOW_IF_NOT_EMPTY);
        this.$element.on('keyup', this.change.bind(this));
        this.$element.on('change', this.change.bind(this));

        log('ready', this.$element);

        this.change();
    }

    _createClass(ShowOnChange, [{
        key: 'change',
        value: function change() {
            var isChecked = this.$element.is(':checkbox') || this.$element.is(':radio') ? this.$element.is(':checked') : true;
            this.value = this.$element.val();
            if (this.$element.length > 1 && isChecked) {
                var selector = this.$element.attr(ATTR_ELEMENT_SELECTOR);
                this.value = $(selector + ':checked').val();
            }
            if (this.value == null) {
                this.value = '';
            }

            log('change', this.$element, this.value, this.initial);
            if (this.showIfNotEmpty) {
                if (this.value.length > 0) {
                    this.$elementToShow.show();
                } else {
                    this.$elementToShow.hide();
                }
            }
        }
    }]);

    return ShowOnChange;
}();

(0, _plugin2.default)(PLUGIN_NAME, ShowOnChange);

function exec() {
    $(document).ready(function () {
        $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\simple-modal\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-simple-modal]';
var PLUGIN_NAME = 'SimpleModal';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--simple-modal").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\simple-modal\\simple-modal.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\site-header\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-header-controller]";
var PLUGIN_NAME = "headerController";

var log = (0, _debug2.default)("site-header/header-controller:header");

function truthy(value) {
	return value;
}

function uniqueOnly(value, index, self) {
	return self.indexOf(value) === index;
}

function getOverlaySelector(opener) {
	return opener.dataset["headerController-UseOverlay"];
}

function findElement(selector) {
	return document.querySelector(selector);
}

var HeaderController = function () {
	function HeaderController(element, options) {
		_classCallCheck(this, HeaderController);

		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.collapsibles = [].concat(_toConsumableArray(this.element.querySelectorAll(this.options.collapsibleSelector)));
		this.overlays = this.collapsibles.map(getOverlaySelector).filter(uniqueOnly).filter(truthy).map(findElement);

		this.watch();

		log("ready", this, this.$target);
	}

	_createClass(HeaderController, [{
		key: "watch",
		value: function watch() {
			log("watching");

			this.element.addEventListener(this.options.childOpenedEvent, this.handleOpening.bind(this));
			this.element.addEventListener(this.options.childClosedEvent, this.handleClosing.bind(this));
			this.element.addEventListener(this.options.closeAllEvent, this.closeAllCollapsibles.bind(this));

			if (this.options.closeWithDocumentClick) {
				document.addEventListener('click', this.handleDocumentClick.bind(this));
			} else {
				// Overlays only need click events if document is capturing
				this.overlays.forEach(this.bindOverlay.bind(this));
			}
		}
	}, {
		key: "bindOverlay",
		value: function bindOverlay(element) {
			element.addEventListener("click", this.closeAllCollapsibles.bind(this));
		}
	}, {
		key: "closeAllCollapsibles",
		value: function closeAllCollapsibles() {
			this.collapsibles.forEach(function (item) {
				var collapseStateAttr = item.dataset["headerController-Collapsible"];
				item.dataset[collapseStateAttr] = false;
			});
			this.hideAllOverlays();
		}
	}, {
		key: "closeOtherCollapsibles",
		value: function closeOtherCollapsibles(opener) {
			var toCollapse = this.collapsibles.filter(function (item) {
				return item !== opener;
			});

			toCollapse.forEach(function (item) {
				var collapseStateAttr = item.dataset["headerController-Collapsible"];
				item.dataset[collapseStateAttr] = false;
			});
		}
	}, {
		key: "handleDocumentClick",
		value: function handleDocumentClick(event) {
			if (!this.isWithinCollapsible(event.target)) {
				this.closeAllCollapsibles();
			}
		}
	}, {
		key: "isWithinCollapsible",
		value: function isWithinCollapsible(element) {
			return this.collapsibles.some(function (container) {
				return container === element || container.contains(element);
			});
		}
	}, {
		key: "handleOpening",
		value: function handleOpening(event) {
			var opener = event.target;

			// Only respond to specified collapsibles
			if (!this.collapsibles.includes(opener)) {
				return false;
			}
			this.closeOtherCollapsibles(opener);
			this.displayOverlay(opener);
		}

		// Presumes the closing event is called only when the collapsible closes itself
		//	Not when it is closed externally

	}, {
		key: "handleClosing",
		value: function handleClosing(event) {

			// Only respond to specified collapsibles
			if (!this.collapsibles.includes(event.target)) {
				return false;
			}

			this.hideOverlay(event.target);
		}

		// display specified overlay

	}, {
		key: "displayOverlay",
		value: function displayOverlay(opener) {
			var selector = getOverlaySelector(opener);
			var overlay = document.querySelector(selector);

			if (overlay) {
				overlay.hidden = false;
				this.hideOtherOverlays(overlay);
			} else {
				this.hideAllOverlays();
			}
		}
	}, {
		key: "hideOverlay",
		value: function hideOverlay(opener) {
			var selector = getOverlaySelector(opener);
			var overlay = document.querySelector(selector);

			if (overlay) {
				overlay.hidden = true;
			}
		}
	}, {
		key: "hideOtherOverlays",
		value: function hideOtherOverlays(overlay) {
			var overlaysToHide = this.overlays.filter(function (element) {
				return element !== overlay;
			});
			overlaysToHide.forEach(function (element) {
				return element.hidden = true;
			});
		}

		// Hide all overlays

	}, {
		key: "hideAllOverlays",
		value: function hideAllOverlays() {
			this.overlays.forEach(function (element) {
				return element.hidden = true;
			});
		}
	}]);

	return HeaderController;
}();

HeaderController.DEFAULTS = {
	childOpenedEvent: 'collapsibleOpened',
	childClosedEvent: 'collapsibleClosed',
	closeAllEvent: 'closeCollapibles'
};

(0, _lib2.default)(PLUGIN_NAME, HeaderController);

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\sliders\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/modules/sliders'; /* global $:true module:true Flickity:true Foundation:true */

var ELEMENT_SELECTOR = '.block-slider';
var log = (0, _debug2.default)(MODULE_NAME);

$(function () {
	if ($(ELEMENT_SELECTOR).length) {
		__webpack_require__.e/* import() */("block-slider").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\sliders\\blocks.js")).then(function (module) {
			module.default();
		});
	}
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\sortable-products\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLUGIN_NAME = 'sortableProducts';
var ELEMENT_SELECTOR = '[data-sortable-products]';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--sortable-products").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\sortable-products\\sortable-products.js")).then(function (module) {
			(0, _plugin2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\submits-on-changed\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-submits-on-changed]';
var PLUGIN_NAME = 'SubmitsOnChanged';

$(function () {
    $(ELEMENT_SELECTOR).each(function () {
        var element = this;
        __webpack_require__.e/* import() */("plugin--submits-on-changed").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\submits-on-changed\\submits-on-changed.js")).then(function (module) {
            (0, _lib2.default)(PLUGIN_NAME, module.default);
            $(element)[PLUGIN_NAME]();
        });
    });

    $(document).on('filter-groups-loaded', function () {
        $(ELEMENT_SELECTOR).each(function () {
            var element = this;
            __webpack_require__.e/* import() */("plugin--submits-on-changed").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\submits-on-changed\\submits-on-changed.js")).then(function (module) {
                (0, _lib2.default)(PLUGIN_NAME, module.default);
                $(element)[PLUGIN_NAME]();
            });
        });
    });
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-grid\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-grid\\swatch-grid--split.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-grid\\swatch-grid--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-swatch-grid]';
var PLUGIN_NAME = 'SwatchGrid';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("swatch-grid").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-grid\\swatch-grid.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-row\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-row\\swatch-row--split.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-row\\swatch-row--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-swatch-row]';
var PLUGIN_NAME = 'SwatchRow';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("swatch-row").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-row\\swatch-row.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});

	$(document).on('product-teasers-loaded', function () {
		$(ELEMENT_SELECTOR).each(function () {
			var element = this;
			__webpack_require__.e/* import() */("swatch-row").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swatch-row\\swatch-row.js")).then(function (module) {
				(0, _lib2.default)(PLUGIN_NAME, module.default);
				$(element)[PLUGIN_NAME]();
			});
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swiper\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _swiper = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swiper\\swiper.js");

var swiper = _interopRequireWildcard(_swiper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function exec() {
	$(document).ready(function () {
		swiper.exec();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swiper\\product-slider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _gaServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\ga-services.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-product-slider]";
var HEIGHT_SELECTOR = ".product-teaser__container";
var BULLET_SELECTOR = ".swiper-pagination-bullet";
var HIDE_NAVIGATION_CLASS = "swiper--hide-navigation";

var ProductSlider = function () {
	function ProductSlider(element, options) {
		_classCallCheck(this, ProductSlider);

		this.element = element;
		this.options = options;
		this.swiper = window.swiper;
		this.slides = $(element).find(".swiper-slide");
		this.nextButton = document.querySelector(this.options.nextButtonSelector);
		this.previousButton = document.querySelector(this.options.previousButtonSelector);
		this.$el = $(this.element);
		if (typeof this.swiper == "undefined") {
			var mod = this;
			__webpack_require__.e/* import() */("core/vendor/swiper/swiper-bundle.min").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\vendor\\swiper\\swiper-bundle.min.js")).then(function (swiper) {
				mod.swiper = swiper;
				window.swiper = swiper;
				mod.init();
			});
		} else {
			this.init();
		}
	}

	_createClass(ProductSlider, [{
		key: "setAnySlidesClass",
		value: function setAnySlidesClass() {
			var bullets = $(this.element).find(BULLET_SELECTOR);
			if (bullets.length > 1) {
				$(this.element).removeClass(HIDE_NAVIGATION_CLASS);
			} else {
				$(this.element).addClass(HIDE_NAVIGATION_CLASS);
			}
		}
	}, {
		key: "init",
		value: function init() {
			var _this = this;

			var mod = this;
			this.slider = new this.swiper(this.element, {
				slidesPerView: 2,
				slidesPerGroup: 2,
				// slidesPerGroupSkip: 2,
				// spaceBetween: 0,
				centeredSlides: false,
				// cssMode: true,
				mousewheel: false,
				keyboard: {
					enabled: true
				},
				// loop: true,
				// loopFillGroupWithBlank: true,
				slideVisibleClass: 'slide-active',
				watchSlidesVisibility: true,
				breakpoints: {
					640: {
						slidesPerView: 2,
						slidesPerGroup: 2
					},
					768: {
						slidesPerView: 3,
						slidesPerGroup: 3
					},
					1024: {
						slidesPerView: 4,
						slidesPerGroup: 4
					}
				},
				on: {
					init: function init() {
						setTimeout(function () {
							mod.setAnySlidesClass();
						}, 200);
					},
					resize: function resize() {
						mod.setAnySlidesClass();
					},
					slideChangeTransitionEnd: function slideChangeTransitionEnd() {
						mod.tracking();
					}
				},
				pagination: {
					el: ".swiper-pagination",
					type: "bullets",
					bulletElement: "button",
					bulletClass: "swiper-pagination-bullet",
					renderBullet: function renderBullet(index, className) {
						return "<button type=\"button\" class=\"" + className + " u-focus-keyboard--circle\" aria-label=\"Go to slide " + index + "\"></button>";
					},
					clickable: true
				},
				navigation: {
					nextEl: mod.nextButton,
					prevEl: mod.previousButton
				},
				threshold: 20
			});

			this.trackingSelect();
			this.tracking();
			$(window).on('scroll', function () {
				_this.tracking();
			});
		}
	}, {
		key: "tracking",
		value: function tracking() {
			var $tabBlock = this.$el.closest('.has-tab');
			if ($tabBlock.length) {
				var $activeTab = $tabBlock.find('.recommendations-slider-content:not(.--is-closed)');
				if (this.$el.parents('.recommendations-slider-content:not(.--is-closed)').length > 0) {
					_gaServices.GAServices.viewItemTracking($activeTab, true);
				}
			} else {
				_gaServices.GAServices.viewItemTracking($(this.element), true);
			}
		}
	}, {
		key: "trackingSelect",
		value: function trackingSelect() {
			var _this2 = this;

			var $tabs = this.$el.closest('.has-tab');
			var pageType = $('body').data('pageTypeName');
			this.$el.find('[ga-tracking-link]').each(function (index, el) {
				if (!$tabs.length) {
					var $block = _this2.$el.closest('.layout');
					if ($block) {
						var $blockTitle = $block.find('.layout__title');
						var itemListName = pageType + ' - ' + $blockTitle.text().trim();
						el.closest('[ga-tracking-item]').setAttribute('ga-item-list-name', itemListName);
					}
				}
				_gaServices.GAServices.selectItem(el, false);
			});
		}
	}]);

	return ProductSlider;
}();

ProductSlider.DEFAULTS = {};

(0, _plugin2.default)("productSlider", ProductSlider);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR).productSlider();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swiper\\swiper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _productSlider = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\swiper\\product-slider.js");

var productSlider = _interopRequireWildcard(_productSlider);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-swiper]';
var ATTR = 'data-swiper';
var THUMBNAILS_ATTR = '[data-swiper-thumbnails="{0}"]';
var SLIDE_SELECTOR = '.swiper-slider';
var TRANSITION_START_CLASS = 'swiper-slider--transition';

var SwiperPlugin = function () {
    function SwiperPlugin(element, options) {
        _classCallCheck(this, SwiperPlugin);

        this.element = element;
        this.options = options;
        this.code = $(element).attr(ATTR);
        this.thumbnails = $(THUMBNAILS_ATTR.replace('{0}', this.code));
        this.hasThumbnails = typeof this.thumbnails !== 'undefined' && this.thumbnails.length > 0;
        this.iframeSlides = $(element).find('.swiper-slide iframe');

        var mod = this;
        __webpack_require__.e/* import() */("core/vendor/swiper/swiper-bundle.min").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\vendor\\swiper\\swiper-bundle.min.js")).then(function (swiper) {
            mod.swiper = swiper;
            window.swiper = swiper;
            mod.init();
            productSlider.exec();
        });
    }

    // setIframeHeight() {
    //     for(var i=0;i<this.iframeSlides.length;i++) {
    //         var frame = this.iframeSlides[i];
    //         var width = $(frame).width();
    //         $(frame).css('height', width);
    //     }
    // }

    _createClass(SwiperPlugin, [{
        key: 'setTransitionStart',
        value: function setTransitionStart() {
            $(this.element).addClass(TRANSITION_START_CLASS);
        }
    }, {
        key: 'setTransitionEnd',
        value: function setTransitionEnd() {
            $(this.element).removeClass(TRANSITION_START_CLASS);
        }
    }, {
        key: 'init',
        value: function init() {
            var mod = this;
            // $(window).on('resize',function() {
            //     mod.setIframeHeight();
            // });
            if (this.hasThumbnails) {
                var totalThumbs = this.thumbnails.find(SLIDE_SELECTOR);
                var slidesPerView = totalThumbs < 7 ? totalThumbs : 7;
                var galleryThumbs = new this.swiper('.gallery-thumbs', {
                    slidesPerView: slidesPerView,
                    spaceBetween: 10,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true
                    }
                });

                this.thumbnailsSlider = galleryThumbs;

                this.slider = new this.swiper(this.element, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    thumbs: {
                        swiper: galleryThumbs
                    },
                    on: {
                        transitionEnd: function transitionEnd() {
                            mod.setTransitionEnd();
                        },
                        transitionStart: function transitionStart() {
                            mod.setTransitionStart();
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next-product',
                        prevEl: '.swiper-button-prev-product'
                    }
                });
            } else {
                this.slider = new this.swiper(this.element, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    on: {
                        transitionEnd: function transitionEnd() {
                            mod.setTransitionEnd();
                        },
                        transitionStart: function transitionStart() {
                            mod.setTransitionStart();
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next-product',
                        prevEl: '.swiper-button-prev-product'
                    }
                });
            }

            $(window).on('reinit-swiper', function () {
                mod.slider.update();
                if (mod.hasThumbnails) {
                    mod.thumbnailsSlider.update();
                }
            });

            $(window).trigger('resize');
        }
    }]);

    return SwiperPlugin;
}();

SwiperPlugin.DEFAULTS = {};

(0, _plugin2.default)('swiperPlugin', SwiperPlugin);

function exec() {
    $(document).ready(function () {
        $(ELEMENT_SELECTOR).swiperPlugin();
        if ($(ELEMENT_SELECTOR).length == 0) {
            productSlider.exec();
        }
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\tabs\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-tabs-controller]';
var PLUGIN_NAME = 'tabsController';

var log = (0, _debug2.default)('tabs-controller');

var TabsController = function () {
	function TabsController(element, options) {
		_classCallCheck(this, TabsController);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.tabs = this.selectors.selectTarget(this.options.tabsSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(TabsController, [{
		key: 'watch',
		value: function watch() {
			log('watching');
			this.$element.on('closeothers', this.closeOtherTabs.bind(this));
		}
	}, {
		key: 'closeOtherTabs',
		value: function closeOtherTabs(event) {
			var openingTab = event.target;

			var tabsToClose = this.tabs.filter(function (index, tab) {
				return tab !== openingTab;
			});

			tabsToClose.each(function (index, tab) {
				tab.dataset.collapsibleOpen = false;
			});

			window.dispatchEvent(new Event('resize'));
		}
	}]);

	return TabsController;
}();

TabsController.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, TabsController);

function exec() {
	(0, _jquery2.default)(document).ready(function () {
		(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\toggle-class\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import plugin from '../../lib/plugin';

var MODULE_NAME = 'app.core/modules/toggle-class';
var log = (0, _debug2.default)(MODULE_NAME);

var TOGGLE_ELEMENT_ATTR = 'data-toggle-element';
var TOGGLE_ELEMENT_SELECTOR = '[' + TOGGLE_ELEMENT_ATTR + ']';

var TOGGLE_WITH_ELEMENT_ATTR = 'data-toggle-with-element';
var TOGGLE_WITH_ELEMENT_SELECTOR = '[' + TOGGLE_WITH_ELEMENT_ATTR + ']';

var HIDE_WITH_ELEMENT_ATTR = 'data-hide-with-element';

var TOGGLE_CLASSNAME_ATTR = 'data-toggle-class-name';

var TOGGLE_CLASS_ELEMENT_ATTR = 'data-toggle-class-target';
var TOGGLE_CLASS_ELEMENT_SELECTOR = '[' + TOGGLE_CLASS_ELEMENT_ATTR + ']';

var CHECK_TOGGLE_ELEMENT_ATTR = 'data-check-toggle-class-target';
var CHECK_TOGGLE_ELEMENT_SELECTOR = '[' + CHECK_TOGGLE_ELEMENT_ATTR + ']';

var CHECK_TOGGLE_CLASSNAME_ATTR = 'data-check-toggle-class-name';

var CHECK_TOGGLE_EVENT_ATTR = 'data-check-toggle-event';
var CHECK_TOGGLE_EVENT_SELECTOR = '[' + CHECK_TOGGLE_EVENT_ATTR + ']';

function toggleElementClassname($e) {
    $e.preventDefault();
    var $this = $(this);
    var target = $this.attr(TOGGLE_CLASS_ELEMENT_ATTR);
    var classname = $this.attr(TOGGLE_CLASSNAME_ATTR);
    var targets = target.split(',');
    var classnames = classname.split(',');
    if (targets.length == classnames.length) {
        for (var i = 0; i < targets.length; i++) {
            var cssClass = classnames[i];
            var targ = targets[i];
            $(targ).toggleClass(cssClass);
        }
    }
}

var defaultCheck = function defaultCheck($element, classname) {
    return $element.has(classname);
};

function checkToggleClass($trigger) {
    var checkFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCheck;

    if ($trigger.length) {
        var target = $trigger.attr(CHECK_TOGGLE_ELEMENT_ATTR);
        var classname = $trigger.attr(CHECK_TOGGLE_CLASSNAME_ATTR);

        $(target).toggleClass(classname, checkFn($trigger, classname));
    }
}

function checkToggleEvent($trigger) {
    if ($trigger.length) {
        var eventName = $trigger.attr(CHECK_TOGGLE_EVENT_ATTR);
        var isUnchecked = !$trigger.is(':checked');

        $(document).trigger(eventName, isUnchecked);
    }
}

function toggleElement() {
    var $this = $(this);
    var target = $this.attr(TOGGLE_ELEMENT_ATTR);

    $(target).toggle();
}

function toggleWithElement() {
    var $this = $(this);
    var target = $this.attr(TOGGLE_WITH_ELEMENT_ATTR);
    var hideTarget = $this.attr(HIDE_WITH_ELEMENT_ATTR);

    $(hideTarget).hide();
    $(target).show();
}

function exec() {
    $(TOGGLE_CLASS_ELEMENT_SELECTOR).on('click', toggleElementClassname);

    $(TOGGLE_WITH_ELEMENT_SELECTOR).on('click', toggleWithElement);

    $(TOGGLE_ELEMENT_SELECTOR).on('click', toggleElement);

    $(CHECK_TOGGLE_EVENT_SELECTOR).on('change', function () {
        checkToggleEvent($(this));
    });

    $(CHECK_TOGGLE_ELEMENT_SELECTOR).on('change', function () {
        checkToggleClass($(this));
    });

    $(document).on('async_update', function (event, context) {
        log('element', $(context).find(CHECK_TOGGLE_ELEMENT_SELECTOR));

        $(context).find(CHECK_TOGGLE_ELEMENT_SELECTOR).on('change', function () {
            checkToggleClass($(this));
        });

        $(TOGGLE_CLASS_ELEMENT_SELECTOR).on('click', toggleElementClassname);
    });

    $(document).on('filter-groups-loaded', function (event, context) {
        $(TOGGLE_CLASS_ELEMENT_SELECTOR).off('click');
        $(TOGGLE_CLASS_ELEMENT_SELECTOR).on('click', toggleElementClassname);
    });

    $(document).ready(function () {
        checkToggleClass($(CHECK_TOGGLE_ELEMENT_SELECTOR), function ($element) {
            return $element.is(':checked');
        });

        checkToggleEvent($(CHECK_TOGGLE_EVENT_SELECTOR));
    });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\update-cart\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-update-cart]';
var PLUGIN_NAME = 'UpdateCart';

$(function () {
	$(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--update-cart").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\update-cart\\update-cart.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\video-block\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-video-block]';
var PLUGIN_NAME = 'VideoBlock';

(0, _jquery2.default)(function () {

	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("video-block").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\video-block\\video-block.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\windcave-iframe-container\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _cartCheck = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\cart-check\\cart-check.js");

var _cartCheck2 = _interopRequireDefault(_cartCheck);

var _loadingGlobal = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\loading-global.js");

var _loadingGlobal2 = _interopRequireDefault(_loadingGlobal);

var _gaServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\ga-services.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLUGIN_NAME = "windcaveIframeContainer";
var ELEMENT_SELECTOR = "[data-windcave-iframe-container]";
var Promise = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\es6-promise\\dist\\es6-promise.js").Promise;
var log = (0, _debug2.default)(PLUGIN_NAME);
var windcaveApi;

// Allowing space for two tall validation errors at 320px viewport
var IFRAME_HEIGHT_NEW_CARD = 580;

// CVC input only
var IFRAME_HEIGHT_SAVED_CARD = 380;

// NOTE: Need to be running under https to see this working

var WindcaveIframeContainer = function () {
	function WindcaveIframeContainer(element, options) {
		_classCallCheck(this, WindcaveIframeContainer);

		this.element = element;
		this.options = options;
		this.$element = $(element);

		if (!this.options.url) {
			log("Missing url. data-windcave-iframe-container-url=\"...\" Aborting");
			return false;
		}
		this.url = this.options.url;

		if (!this.options.processPaymentUrl) {
			log("Missing process payment url. data-windcave-iframe-container-process-payment-url=\"...\" Aborting");
			return false;
		}

		if (!this.options.errorElementSelector) {
			log("Error element selector not provided. data-windcave-iframe-container-error-element-selector=\"...\" Aborting");
			return false;
		}

		this.$errorElement = $(this.options.errorElementSelector);

		if (!this.$errorElement[0]) {
			log("Element matching error element selector not found. data-windcave-iframe-container-error-element-selector=\"" + this.options.errorElementSelector + "\" Aborting");
			return false;
		}

		if (!this.options.sessionId) {
			log("Session id not provided. data-windcave-iframe-container-session-id=\"...\" Aborting");
			return false;
		}
		this.sessionId = this.options.sessionId;

		this.loadingElement = document.querySelector(this.options.loadingSelector);

		if (!this.options.sessionId) {
			log("Saved or new card option not provided. data-windcave-iframe-container-saved-or-new-card=\"...\" Aborting");
			return false;
		}
		this.savedOrNewCard = this.options.savedOrNewCard;

		this.$submitButton = $("#" + this.options.submitButtonId);
		if (!this.$submitButton[0]) {
			log("Element matching submit button id not found (\"" + this.options.submitButtonId + "\"). data-windcave-iframe-container-submit-button-id=\"...\" Aborting");
			return false;
		}

		this.paymentFormComponent = document.querySelector(this.options.paymentFormComponentSelector);

		if (this.paymentFormComponent) {
			this.cartCheckEndpoint = this.paymentFormComponent.dataset["paymentFormCartCheckEndpoint"];
			this.cartCheckRedirectPath = this.paymentFormComponent.dataset["paymentFormCartCheckRedirectPath"];
		}

		log("construct", element, options);
		this.init();
	}

	_createClass(WindcaveIframeContainer, [{
		key: "init",
		value: function init() {
			log("init");
			var mod = this;
			this.initWindcaveApi().then(function () {
				log("Windcave JS loaded");
				mod.initWindcaveSeamlessPayments();
				mod.updateWindcaveSubmitPurpose();
			}).catch(function (reason) {
				log("Windcave JS js not loaded", reason);

				// Or maybe it is loaded??
				if (typeof window.WindcavePayments !== "undefined") {
					log("Windcave API promise timeout. Setting from window.");
					mod.windcaveApi = window.WindcavePayments;
					mod.initWindcaveSeamlessPayments();
					mod.updateWindcaveSubmitPurpose();
				} else {
					mod.errorMessage = "Unable to load windcave API";
					mod.showError();
				}
			});

			this.watch();
		}
	}, {
		key: "watch",
		value: function watch() {
			document.addEventListener("update-windcave-url", this.onUrlUpdate.bind(this));
		}
	}, {
		key: "onUrlUpdate",
		value: function onUrlUpdate(event) {
			var url = event.detail["url"];
			var savedOrNewCard = event.detail["savedOrNewCard"];
			var sessionId = event.detail["sessionId"];

			if (!sessionId) {
				return false;
			}

			this.updateWindcaveUrl(url, savedOrNewCard, sessionId);
		}
	}, {
		key: "loadWindcaveAPI",
		value: function loadWindcaveAPI() {
			var windowRef = window ? window : {};
			var script = document.createElement("script");

			script.type = "text/javascript";

			script.src = "https://sec.windcave.com/js/windcavepayments-seamless-v1.js";
			script.onload = function () {
				windowRef.windcaveApiLoaded();
			};
			document.querySelector("head").appendChild(script);
		}
	}, {
		key: "initWindcaveApi",
		value: function initWindcaveApi() {
			if (this.windcaveApi) {
				return Promise.resolve(windcaveApi);
			}

			var mod = this;
			var windowRef = window ? window : {};

			_loadingGlobal2.default.show();

			var deferred = function deferred(resolve, reject) {
				windowRef.windcaveApiLoaded = function () {
					if (windowRef.WindcavePayments) {
						mod.windcaveApi = windowRef.WindcavePayments;
						_loadingGlobal2.default.hide();
						resolve();
					}
				};

				mod.loadWindcaveAPI();

				setTimeout(function () {
					if (!windowRef.windcaveApi) {
						reject(new Error("Loading took too long"));
					}
				}, 5000);
			};

			return new Promise(deferred);
		}
	}, {
		key: "initWindcaveSeamlessPayments",
		value: function initWindcaveSeamlessPayments() {
			if (this.windcaveApi) {
				var heightNewCard = IFRAME_HEIGHT_NEW_CARD;
				var heightSavedCard = IFRAME_HEIGHT_SAVED_CARD;
				var height = this.savedOrNewCard == "saved" ? heightSavedCard : heightNewCard;
				this.$errorElement.hide();
				var mod = this;
				this.element.hidden = true;
				_loadingGlobal2.default.show();

				this.windcaveApi.Seamless.prepareIframe({
					url: this.url,
					containerId: this.options.containerId,
					enableValidationOnFieldExit: true,
					loadTimeout: 30,
					width: 400,
					height: height,
					threeDS: {
						// this is an iframe within the parent iframe that contains styles that presume it is at least as tall as the parent iframe
						width: 400,
						height: 580
					},
					onProcessed: function onProcessed(result) {
						log("processed", result);
						mod.hideLoading();
						_loadingGlobal2.default.hide();

						var eventName = {
							"done": "windcave_prepare_iframe_done",
							"3DSecure": "windcave_prepare_iframe_3dsecure",
							"loaded": "windcave_prepare_iframe_loaded"
						};

						hj("event", eventName[result] || "windcave_prepare_iframe_unknown");
					},
					onError: function onError(error) {
						log("error", error);
						mod.errorMessage = "Error loading windcave iframe: " + error;
						mod.showError();
						mod.hideLoading();
						_loadingGlobal2.default.hide();

						var eventName = {
							"timeout": "windcave_prepare_iframe_error_timeout",
							"browser-not-supported": "windcave_prepare_iframe_error_unsupported",
							"action-in-process": "windcave_prepare_iframe_error_action_in_process",
							"no-container": "windcave_prepare_iframe_error_no_container",
							"invalid-url": "windcave_prepare_iframe_error_invalid_url",
							"session-error": "windcave_prepare_iframe_error_session",
							"finished": "windcave_prepare_iframe_error_finished"
						};

						hj("event", eventName[error] || "windcave_prepare_iframe_error_unknown");
					}
				});
			}
		}
	}, {
		key: "updateWindcaveUrl",
		value: function updateWindcaveUrl(url, savedOrNewCard, sessionId) {
			this.url = url;
			this.savedOrNewCard = savedOrNewCard;
			this.sessionId = sessionId;
			this.initWindcaveSeamlessPayments();
		}
	}, {
		key: "forceRefund",
		value: function forceRefund() {
			document.dispatchEvent(new CustomEvent('forceRefund'));
		}
	}, {
		key: "showLoading",
		value: function showLoading() {
			this.loadingElement.hidden = false;
			this.element.hidden = true;
		}
	}, {
		key: "hideLoading",
		value: function hideLoading() {
			this.loadingElement.hidden = true;
			this.element.hidden = false;
		}
	}, {
		key: "disablePaymentSubmit",
		value: function disablePaymentSubmit() {
			this.$submitButton.attr("disabled", "");
			this.$submitButton.addClass("is-submitting");
		}
	}, {
		key: "enablePaymentSubmit",
		value: function enablePaymentSubmit() {
			this.$submitButton.removeAttr("disabled");
			this.$submitButton.removeClass("is-submitting");
		}
	}, {
		key: "processPayment",
		value: function processPayment() {
			var _this = this;

			this.requestKey = "" + Date.now();
			var mod = this;
			var endpoint = this.options.processPaymentUrl + "&requestKey=" + this.requestKey + "&sessionId=" + this.sessionId;

			mod.showLoading();
			hj("event", "process_payment");

			fetch(endpoint).then(function (response) {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			}).then(function (data) {
				log("data", data);
				// Ignore all but the most recent request
				if (data.RequestKey === _this.requestKey) {
					if (data.Success) {
						hj("event", "process_payment_success");
						window.location = data.RedirectUrl;
					} else {
						hj("event", "process_payment_fail");
						mod.errorMessage = data.ErrorMessage;
						mod.sessionId = data.SessionId;
						mod.url = data.FormPostUrl;

						mod.initWindcaveSeamlessPayments();
						mod.enablePaymentSubmit();
						mod.showError();
					}
				}
			}).catch(function (error) {
				log("error", error);
				mod.errorMessage = "Error processing payment: " + error;
				hj("event", "process_payment_error");
				mod.enablePaymentSubmit();
				mod.showError();
			});
		}
	}, {
		key: "showError",
		value: function showError() {
			this.$errorElement.find(this.options.errorMessageSelector).text(this.errorMessage);
			this.$errorElement.removeAttr("hidden").show();
		}
	}, {
		key: "validateForm",
		value: function validateForm() {
			if (this.windcaveApi) {
				var mod = this;
				this.$errorElement.hide();
				this.windcaveApi.Seamless.validate({
					onProcessed: function onProcessed(result) {
						if (result) {
							hj("event", "windcave_validate_valid");
							mod.windcaveApi.Seamless.submit({
								showSpinner: true,
								onProcessed: function onProcessed(result) {
									_gaServices.GAServices.sendPaymentInfo();
									hj("event", "windcave_submit_success");
									log("Processed and valid", result);
									if (result == "done") {
										hj("event", "windcave_submit_done");
										mod.disablePaymentSubmit();
										mod.processPayment();
									} else if (result == "3DSecure") {
										hj("event", "windcave_submit_3dsecure");
									}
								},
								onError: function onError(error) {
									log(error);
									mod.forceRefund();
									mod.errorMessage = "Error submitting payment: " + error;
									mod.enablePaymentSubmit();
									mod.showError();
									hj("event", "windcave_submit_error");
								}
							});
						} else {
							hj("event", "windcave_validate_invalid");
						}
					},
					onError: function onError(error) {
						log("Error and invalid", error);
						mod.errorMessage = "Validation error: " + error;
						mod.enablePaymentSubmit();
						mod.showError();
						mod.forceRefund();

						var eventName = {
							"not-ready": "windcave_validate_error_not_ready",
							"action-in-process": "windcave_validate_error_action_in_process",
							"exception": "windcave_validate_error_exception"
						};

						hj("event", eventName[error] || "windcave_validate_error_unknown");
					}
				});
			}
		}
	}, {
		key: "updateWindcaveSubmitPurpose",
		value: function updateWindcaveSubmitPurpose() {
			this.$submitButton[0].addEventListener("click", this.submitButtonHandler.bind(this));
		}
	}, {
		key: "submitButtonHandler",
		value: function submitButtonHandler() {
			var _this2 = this;

			if (!this.cartCheckEndpoint) {
				this.validateForm();
			} else {
				(0, _cartCheck2.default)(this.cartCheckEndpoint).then(function (count) {
					if (!count) {
						log("Empty cart!");
						hj("event", "submit_cart_check_empty");
						_this2.redirectToCart();
					} else {
						_this2.validateForm();
					}
				}).catch(function (error) {
					log("Cart check failed!", error);
					hj("event", "submit_cart_check_fail");
					_this2.redirectToCart();
				});
			}
		}
	}, {
		key: "redirectToCart",
		value: function redirectToCart() {
			if (this.cartCheckRedirectPath) {
				window.location.pathname = this.cartCheckRedirectPath;
			}
		}
	}]);

	return WindcaveIframeContainer;
}();

WindcaveIframeContainer.DEFAULTS = {
	containerId: "windcaveIframe",
	submitButtonId: "cc-checkout",
	errorMessageSelector: ".notification__message"
};

(0, _plugin2.default)(PLUGIN_NAME, WindcaveIframeContainer);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\wysiwyg\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\wysiwyg\\table\\index.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\wysiwyg\\table\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\wysiwyg\\table\\tables.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\wysiwyg\\table\\tables.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$('.wysiwyg-area > table').wrap('<div class="scrollable"></div>');

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\zendesk\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\zendesk\\zendesk.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\zendesk\\zendesk.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Prevent unprompted Zendesk chat connection:
// https://support.zendesk.com/hc/en-us/articles/360039299153-Optimizing-Chat-and-Web-Widget-performance
// https://support.zendesk.com/hc/en-us/articles/360038807274-ConnectOnPageLoad-Configuration-best-practices-for-common-use-cases
window.zESettings = {
	webWidget: {
		chat: {
			connectOnPageLoad: false
		}
	}
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\index.js");

var _components = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\index.js");

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core';
var log = (0, _debug2.default)(MODULE_NAME);
log('Running...');

// import services from './services';

$(function () {
    log('Running document ready tasks...');
    log('components', _components2.default);
    _components2.default.exec();
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\loading-global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingGlobal = function () {
	function LoadingGlobal() {
		_classCallCheck(this, LoadingGlobal);

		this.state = [];
		this.isActive = true;
		this.$loading = document.querySelector('[loading-global]');
	}

	_createClass(LoadingGlobal, [{
		key: 'show',
		value: function show() {
			if (this.isActive) {
				this.state.push('');
				this.updateDisplay();
			}
		}
	}, {
		key: 'hide',
		value: function hide() {
			if (this.isActive) {
				this.state.pop();
				this.updateDisplay();
			}
		}
	}, {
		key: 'updateDisplay',
		value: function updateDisplay() {
			if (this.state.length) {
				this.$loading.hidden = false;
			} else {
				this.$loading.hidden = true;
			}
		}
	}, {
		key: 'setActive',
		value: function setActive(isActive) {
			this.isActive = isActive;
			if (!isActive) {
				this.$loading.hidden = true;
				this.state = [];
			}
		}
	}]);

	return LoadingGlobal;
}();

exports.default = new LoadingGlobal();

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = debounce;
exports.collectElementOptions = collectElementOptions;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZERO = 0;

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function collectElementOptions(prefix, data) {
    return Object.keys(data).map(function (key) {
        return (0, _strings.toCamelCase)(key);
    }).filter(function (key) {
        return key.indexOf(prefix) >= ZERO;
    }).reduce(function (result, source) {
        var key = (0, _strings.toCamelCase)(source.replace(prefix, ''));
        result[key] = data[source];
        return result;
    }, {});
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\plugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _strings = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\strings.js");

var _objects = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\objects.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generate a jQuery plugin
 * @param pluginName [string] Plugin name
 * @param className [object] Class of the plugin
 * @param shortHand [bool] Generate a shorthand as $.pluginName
 *
 * @example
 * import plugin from 'plugin';
 *
 * class MyPlugin {
 *     constructor(element, options) {
 *         // ...
 *     }
 * }
 *
 * or
 *
 * function MyPlugin (element, options) {
 *   assert(options.something, true);
 * }
 *
 * then
 *
 * MyPlugin.DEFAULTS = {
 *   something: false
 * };
 *
 * plugin('myPlugin', MyPlugin);
 *
 * $(() => {
 *   $('[data-my-plugin]').myPlugin();
 * })
 *
 * <div data-my-plugin data-my-plugin-something="true"></div>
 */
function plugin(pluginName, className) {
    var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var dataName = '__' + pluginName;
    var old = _jquery2.default.fn[pluginName];
    var ZERO = 0;

    className.$bus = {
        subscribe: function subscribe(event, fn) {
            (0, _jquery2.default)(this).bind(event, fn);
        },
        publish: function publish(event, data) {
            (0, _jquery2.default)(this).trigger(event, [data]);
        }
    };

    _jquery2.default.fn[pluginName] = function PluginFactory(option, args) {
        return this.each(function PluginInstanceFactory() {
            var $this = (0, _jquery2.default)(this);
            var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
            var elementOptions = (0, _objects.collectElementOptions)(pluginName, $this.data());

            var instance = $this.data(dataName);
            var options = _jquery2.default.extend({}, className.DEFAULTS, elementOptions, overrides);

            // store reference to instance
            if (!instance) {
                $this.data(dataName, instance = new className(this, options));
            }

            // execute instance method
            if (typeof option === 'string') {
                if (typeof instance[option] != 'function') {
                    console.warn(pluginName + '.' + option + ' is not a function');
                } else {
                    return instance[option](args);
                }
            }
        });
    };

    // - Short hand
    if (shortHand) {
        _jquery2.default[pluginName] = function (options) {
            return (0, _jquery2.default)({})[pluginName](options);
        };
    }

    // - No conflict
    _jquery2.default.fn[pluginName].noConflict = function noConflict() {
        _jquery2.default.fn[pluginName] = old;
    };
}

_jquery2.default.fn.behaviour = function (name) {
    return (0, _jquery2.default)(this).data('__' + name);
};
function jquery(name) {
    return function decroate(target) {
        plugin(name, target);
    };
}

function defaults(options) {
    return function decorate(target) {
        target.DEFAULTS = options;
    };
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\lib\\strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global Loader:true $:true */

exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/strings';
var log = (0, _debug2.default)(MODULE_NAME);

function toCamelCase(str) {
  return str.replace(/^([A-Z])|[\s-_](\w)/g, function (match, p1, p2) {
    if (p2) {
      return p2.toUpperCase();
    }

    return p1.toLowerCase();
  });
}

function tmpl(str, context) {
  var result = str;

  log('templating ' + result + ' with context: ', context);

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });

    log('templated ' + result);
  }

  return result;
}

function $tmpl(element, context) {
  var $target = $(element);
  var templateString = $target.attr('data-text-template');

  log('templating [' + templateString + '] with context: ', context);
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {
      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }
      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
    });
  }
  return output;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__collapsible\\plugin--bundled.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__mega-link\\plugin--bundled.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__form-loading\\plugin--bundled.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__trigger-event\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__transport-element\\plugin--split.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__inviewport\\plugin--split.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__collapsible\\collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _gaServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\ga-services.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("collapsible");

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var Collapsible = function () {
	function Collapsible(element, options) {
		_classCallCheck(this, Collapsible);

		this.element = element;
		this.$el = $(this.element);
		this.options = options;

		var scopes = {
			document: document,
			element: this.element
		};

		//	Look for the content element within this element or elsewhere
		var contentSelectorIsId = this.options.contentSelector && this.options.contentSelector[0] === "#";

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes["document"];
		} else {
			this.contentSelectorScope = scopes[this.options.contentSelectorScope] ? scopes[this.options.contentSelectorScope] : scopes["element"];
		}

		// if no button is specified perhaps this is the button
		this.button = this.options.buttonSelector ? this.element.querySelector(this.options.buttonSelector) : this.element;

		if (!this.button) {
			log("The provided button selector: \"" + this.options.buttonSelector + "\" failed to match a button. Aborting.");
			return false;
		}

		log(this.element, this.options);

		// Content is optional
		//	we may be toggling with CSS based on aria-expanded button attr
		this.content = this.options.contentSelector && this.contentSelectorScope.querySelector(this.options.contentSelector);
		this.collapseWith = this.options.collapsedClass ? "class" : "hidden";

		// Class could be multiple space separated classes
		this.collapsedClass = this.options.collapsedClass && this.options.collapsedClass.split(" ");

		this.toggleMethod = this.collapseWith === "class" ? this.toggleWithClass : this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.bindDocumentEvents = this.options.closeWithDocumentClick ? this.bindDocumentClick : function () {};

		this.unbindDocumentEvents = this.options.closeWithDocumentClick ? this.unbindDocumentClick : function () {};
		this.init();
		this.watch();
	}

	_createClass(Collapsible, [{
		key: "init",
		value: function init() {
			// component enabled - show the button
			this.button.hidden = false;

			// Determine initial collapse state
			//	if set open option determines init state
			var doCollapse = this.options.open !== undefined ? !this.options.open : true;
			this.initial = true;
			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
			this.setItemListName();
		}
	}, {
		key: "watch",
		value: function watch() {
			this.element.addEventListener('openCollapsible', this.open.bind(this));
			this.button.addEventListener("click", this.toggle.bind(this));
			this.attributeObserver.observe(this.element, { attributes: true });

			if (this.content) {
				this.content.addEventListener("escape", this.toggle.bind(this));
			}

			if (this.options.closeOnPageshow === true) {
				window.addEventListener('pageshow', this.handlePageShow.bind(this));
			}
		}
	}, {
		key: "toggleWithHidden",
		value: function toggleWithHidden(doCollapse) {
			this.button.setAttribute("aria-expanded", !doCollapse);

			if (!this.content) {
				return false;
			}
			this.content.hidden = doCollapse;
		}
	}, {
		key: "toggleWithClass",
		value: function toggleWithClass(doCollapse) {
			var _this = this;

			this.button.setAttribute("aria-expanded", !doCollapse);
			if (!this.content) {
				return false;
			}
			if (doCollapse) {
				this.collapsedClass.forEach(function (className) {
					_this.content.classList.add(className);
				});
			} else {
				this.collapsedClass.forEach(function (className) {
					_this.content.classList.remove(className);
				});
			}
		}
	}, {
		key: "setItemListName",
		value: function setItemListName() {
			var _this2 = this;

			var $tabBlock = this.$el.closest('.tab-recommendation-block');
			var pageType = $('body').data('pageTypeName');
			if ($tabBlock.length) {
				$(this.content).find('[ga-tracking-item]').each(function (index, el) {
					var itemListName = pageType + ' - ' + _this2.$el.text().trim();
					el.closest('[ga-tracking-item]').setAttribute('ga-item-list-name', itemListName);
				});
			}
		}
	}, {
		key: "trackingProductSlider",
		value: function trackingProductSlider() {
			var $tabBlock = this.$el.closest('.has-tab');
			if ($tabBlock.length) {
				var $activeTab = $tabBlock.find('.recommendations-slider-content:not(.--is-closed)');
				_gaServices.GAServices.viewItemTracking($activeTab, true);
			}
		}

		// button click handler

	}, {
		key: "toggle",
		value: function toggle() {
			if (!this.options.selfClosing && !this.isCollapsed) {
				return false;
			}

			var handler = this.isCollapsed ? this.open.bind(this) : this.close.bind(this);
			handler();
		}
	}, {
		key: "open",
		value: function open() {
			this.toggleMethod(false);
			this.isCollapsed = false;
			this.element.dataset.collapsibleOpen = true;
			this.bindDocumentEvents();

			var openedEvent = new CustomEvent(this.options.onUncollapse, {
				bubbles: true,
				cancelable: true
				// detail: {}
			});

			this.element.dispatchEvent(openedEvent);
		}
	}, {
		key: "close",
		value: function close() {
			this.toggleMethod(true);
			this.isCollapsed = true;
			this.element.dataset.collapsibleOpen = false;
			this.unbindDocumentEvents();

			var closedEvent = new CustomEvent(this.options.onCollapse, {
				bubbles: true,
				cancelable: true
			});

			this.element.dispatchEvent(closedEvent);
		}
	}, {
		key: "bindDocumentClick",
		value: function bindDocumentClick() {
			document.addEventListener("click", this.onDocumentClick.bind(this));
		}
	}, {
		key: "unbindDocumentClick",
		value: function unbindDocumentClick() {
			document.removeEventListener("click", this.onDocumentClick);
		}
	}, {
		key: "handlePageShow",
		value: function handlePageShow(event) {
			if (event.persisted && this.isCollapsed === false) {
				this.close();
			}
		}
	}, {
		key: "onDocumentClick",
		value: function onDocumentClick(event) {
			var clickTarget = event.target;

			// clicked this.button
			if (clickTarget === this.button || this.button.contains(clickTarget)) {
				log("clicked button");
				return false;
			}

			// clicked this.content
			if (this.content && (clickTarget === this.content || this.content.contains(clickTarget))) {
				log("clicked content or inside it");
				return false;
			}

			this.close();
		}
	}, {
		key: "onAttributeChange",
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === "attributes" && mutation.attributeName.startsWith("data-collapsible-open");
			}).forEach(this.onOpenChanged.bind(this));
		}
	}, {
		key: "onOpenChanged",
		value: function onOpenChanged(mutation) {
			var doCollapse = !getJSONValue(this.element.dataset.collapsibleOpen);
			if (this.isCollapsed !== doCollapse) {
				this.toggleMethod(doCollapse);
				this.isCollapsed = doCollapse;
				this.trackingProductSlider();
			}
		}
	}]);

	return Collapsible;
}();

Collapsible.DEFAULTS = {
	selfClosing: true,
	onCollapse: "collapsibleClosed",
	onUncollapse: "collapsibleOpened"
};

exports.default = Collapsible;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__collapsible\\plugin--bundled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _collapsible = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__collapsible\\collapsible.js");

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-collapsible]';
var PLUGIN_NAME = 'Collapsible';

(0, _lib2.default)(PLUGIN_NAME, _collapsible2.default);

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__form-loading\\form-loading.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormLoading = function () {
	function FormLoading(element, options) {
		_classCallCheck(this, FormLoading);

		this.element = element;
		this.options = options;
		this.watch();
	}

	_createClass(FormLoading, [{
		key: 'watch',
		value: function watch() {
			this.element.addEventListener("submit", this.applyLoadingState.bind(this));
		}
	}, {
		key: 'applyLoadingState',
		value: function applyLoadingState() {
			this.element.dataset[this.options.dataKey] = this.options.dataValue;
		}
	}]);

	return FormLoading;
}();

FormLoading.DEFAULTS = {
	dataKey: 'state',
	dataValue: 'loading'
};
exports.default = FormLoading;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__form-loading\\plugin--bundled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _formLoading = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__form-loading\\form-loading.js");

var _formLoading2 = _interopRequireDefault(_formLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-form-loading]';
var PLUGIN_NAME = 'FormLoading';

(0, _lib2.default)(PLUGIN_NAME, _formLoading2.default);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__inviewport\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ELEMENT_SELECTOR = exports.PLUGIN_NAME = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLUGIN_NAME = exports.PLUGIN_NAME = "InViewport";
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = "[data-in-viewport]";

if ("IntersectionObserver" in window) {
	(0, _jquery2.default)(function () {
		_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
			__webpack_require__.e/* import() */("plugin--in-viewport").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__inviewport\\in-viewport.js")).then(function (module) {
				(0, _lib2.default)(PLUGIN_NAME, module.default);
				(0, _jquery2.default)(element)[PLUGIN_NAME]();
			});
		});
	});
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__mega-link\\mega-link.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("mega-link");

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var MegaLink = function () {
	function MegaLink(element, options) {
		_classCallCheck(this, MegaLink);

		this.element = element; // li
		this.options = options;

		var scopes = {
			document: document,
			element: this.element
		};

		//	Look for the content element within this element or elsewhere
		var contentSelectorIsId = this.options.contentSelector && this.options.contentSelector[0] === "#";

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes["document"];
		} else {
			this.contentSelectorScope = scopes[this.options.contentSelectorScope] ? scopes[this.options.contentSelectorScope] : scopes["element"];
		}

		this.link = this.element.querySelector(this.options.linkSelector);
		this.button = this.element.querySelector(this.options.buttonSelector);

		this.content = this.contentSelectorScope.querySelector(this.options.contentSelector);
		this.collapseWith = this.options.collapsedClass ? "class" : "hidden";
		this.collapsedClass = this.options.collapsedClass;

		this.toggleMethod = this.collapseWith === "class" ? this.toggleWithClass : this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.bindDocumentEvents = this.options.closeWithDocumentClick ? this.bindDocumentClick : function () {};

		this.unbindDocumentEvents = this.options.closeWithDocumentClick ? this.unbindDocumentClick : function () {};

		this.init();
		this.watch();
	}

	_createClass(MegaLink, [{
		key: "init",
		value: function init() {
			// component enabled - switch link role
			this.link.setAttribute('role', 'button');

			// Determine initial collapse state
			//	if set open option determines init state
			var doCollapse = this.options.open !== undefined ? !this.options.open : true;

			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
		}
	}, {
		key: "watch",
		value: function watch() {
			this.link.addEventListener("click", this.handleUnmodifiedClick.bind(this));
			this.link.addEventListener('keydown', this.handleKeyDown.bind(this));
			this.attributeObserver.observe(this.element, { attributes: true });
			if (this.button) {
				this.button.addEventListener("click", this.toggle.bind(this));
			}

			if (this.options.closeOnPageshow === true) {
				window.addEventListener('pageshow', this.handlePageShow.bind(this));
			}
		}

		// Respond to space key

	}, {
		key: "handleKeyDown",
		value: function handleKeyDown(event) {
			if (event.keyCode === 32) {
				event.preventDefault();
				this.toggle();
			}
		}

		//  Only respond to click without key modifier

	}, {
		key: "handleUnmodifiedClick",
		value: function handleUnmodifiedClick(event) {
			if (!event.ctrlKey && !event.altKey && !event.metaKey) {
				event.preventDefault();
				this.toggle();
			}
		}
	}, {
		key: "toggleWithHidden",
		value: function toggleWithHidden(doCollapse) {
			this.link.setAttribute("aria-expanded", !doCollapse);

			if (!this.content) {
				return false;
			}
			this.content.hidden = doCollapse;
		}
	}, {
		key: "toggleWithClass",
		value: function toggleWithClass(doCollapse) {
			this.link.setAttribute("aria-expanded", !doCollapse);

			if (!this.content) {
				return false;
			}
			if (doCollapse) {
				this.content.classList.add(this.collapsedClass);
			} else {
				this.content.classList.remove(this.collapsedClass);
			}
		}

		// button click handler

	}, {
		key: "toggle",
		value: function toggle() {
			if (!this.options.selfClosing && !this.isCollapsed) {
				return false;
			}

			var handler = this.isCollapsed ? this.open.bind(this) : this.close.bind(this);
			handler();
		}
	}, {
		key: "open",
		value: function open() {
			this.toggleMethod(false);
			this.isCollapsed = false;
			this.element.dataset.megaLinkOpen = true;
			this.bindDocumentEvents();

			var openedEvent = new CustomEvent(this.options.onUncollapse, {
				bubbles: true,
				cancelable: true
				// detail: {}
			});

			this.element.dispatchEvent(openedEvent);
		}
	}, {
		key: "close",
		value: function close() {
			this.toggleMethod(true);
			this.isCollapsed = true;
			this.element.dataset.megaLinkOpen = false;
			this.unbindDocumentEvents();

			var closedEvent = new CustomEvent(this.options.onCollapse, {
				bubbles: true,
				cancelable: true
			});

			this.element.dispatchEvent(closedEvent);
		}
	}, {
		key: "bindDocumentClick",
		value: function bindDocumentClick() {
			document.addEventListener("click", this.onDocumentClick.bind(this));
		}
	}, {
		key: "unbindDocumentClick",
		value: function unbindDocumentClick() {
			document.removeEventListener("click", this.onDocumentClick);
		}
	}, {
		key: "onDocumentClick",
		value: function onDocumentClick(event) {
			var clickTarget = event.target;

			// clicked within element (li)
			if (clickTarget === this.element || this.element.contains(clickTarget)) {
				log("clicked within element");
				return false;
			}

			// clicked this.button
			if (this.button) {
				if (clickTarget === this.button || this.button.contains(clickTarget)) {
					log("clicked button");
					return false;
				}
			}

			// clicked this.link
			if (clickTarget === this.link || this.link.contains(clickTarget)) {
				log("clicked link");
				return false;
			}

			this.close();
		}
	}, {
		key: "handlePageShow",
		value: function handlePageShow(event) {
			if (event.persisted && this.isCollapsed === false) {
				this.close();
			}
		}
	}, {
		key: "onAttributeChange",
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === "attributes" && mutation.attributeName.startsWith("data-mega-link-open");
			}).forEach(this.onOpenChanged.bind(this));
		}
	}, {
		key: "onOpenChanged",
		value: function onOpenChanged(mutation) {
			var doCollapse = !getJSONValue(this.element.dataset.megaLinkOpen);
			if (this.isCollapsed !== doCollapse) {
				this.toggleMethod(doCollapse);
				this.isCollapsed = doCollapse;
			}
		}
	}]);

	return MegaLink;
}();

MegaLink.DEFAULTS = {
	selfClosing: true,
	onCollapse: 'collapsibleClosed',
	onUncollapse: 'collapsibleOpened'
};

exports.default = MegaLink;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__mega-link\\plugin--bundled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _megaLink = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__mega-link\\mega-link.js");

var _megaLink2 = _interopRequireDefault(_megaLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-mega-link]';
var PLUGIN_NAME = 'MegaLink';

(0, _lib2.default)(PLUGIN_NAME, _megaLink2.default);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__transport-element\\plugin--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-transport-element]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'TransportElement';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("plugin--transport-element").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__transport-element\\transport-element.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__trigger-event\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-trigger-event]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'triggerEvent';

(0, _jquery2.default)(function () {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--trigger-event").then(__webpack_require__.bind(null, "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\jquery__trigger-event\\plugin.js")).then(function () {
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\fn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.debounce = debounce;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var API = exports.API = {
	get: function get(url) {
		return fetch(url, {
			headers: {
				"Content-Type": "application/json"
			}
		}).then(function (response) {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		});
	},
	post: function post(url) {
		var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		var _body = Object.assign({
			__RequestVerificationToken: API.getRequestToken()
		}, body);

		var _headers = Object.assign({
			"Content-Type": "application/json"
		}, headers);

		return fetch(url, {
			method: "POST",
			body: JSON.stringify(_body),
			headers: _headers
		}).then(function (response) {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		});
	},
	getRequestToken: function getRequestToken() {
		var requestTokenInputSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]';

		var input = document.querySelector(requestTokenInputSelector);

		if (!input || !input.value) {
			log("Error: Missing __RequestVerificationToken. Aborting");
			return false;
		}
		return input.value;
	}
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                              jQuery plugin
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              import debug from 'debug';
                                                                                                                                                                                                                                                                              import plugin from '@core/plugins/lib';
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              const ELEMENT_SELECTOR = '[data-my-plugin]';
                                                                                                                                                                                                                                                                              const PLUGIN_NAME = 'MyPlugin';
                                                                                                                                                                                                                                                                              const MODULE_NAME = 'plugins/my-plugin';
                                                                                                                                                                                                                                                                              const log = debug(MODULE_NAME);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              class PluginKlass {
                                                                                                                                                                                                                                                                                  constructor(element, options) {
                                                                                                                                                                                                                                                                                    log('new instance', element, options);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.element = element;
                                                                                                                                                                                                                                                                                    this.options = options;
                                                                                                                                                                                                                                                                                    this.$element = $(element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    log('ready', this.$element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.init();
                                                                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              PluginKlass.DEFAULTS = {
                                                                                                                                                                                                                                                                                someCamelCasedProperty: `${PLUGIN_NAME}:something`,
                                                                                                                                                                                                                                                                              };
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              plugin(PLUGIN_NAME, PluginKlass);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              $(document).ready(() => {
                                                                                                                                                                                                                                                                                $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
                                                                                                                                                                                                                                                                              });
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Then using it in html:
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              <div class="something-else"
                                                                                                                                                                                                                                                                                   data-my-plugin
                                                                                                                                                                                                                                                                                   data-my-plugin--some-camel-cased-property="a-string:something-else"></div>
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Styelguide Core.Global.Javascript.JqueryPlugin
                                                                                                                                                                                                                                                                              */

// import * as events from './events';

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _fn = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\fn.js");

var fn = _interopRequireWildcard(_fn);

var _strings = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\strings.js");

var strings = _interopRequireWildcard(_strings);

var _objects = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\objects.js");

var objects = _interopRequireWildcard(_objects);

var _selectors = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js");

var selectors = _interopRequireWildcard(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib');

function plugin(pluginName, klass) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var formattedPluginName = (0, _strings.toCamelCase)(pluginName);
  var dataName = '__' + formattedPluginName;
  var old = _jquery2.default.fn[formattedPluginName];
  var ZERO = 0;

  klass.$bus = {
    subscribe: function subscribe(event, fn) {
      (0, _jquery2.default)(this).bind(event, fn);
    },
    publish: function publish(event, data) {
      (0, _jquery2.default)(this).trigger(event, [data]);
    }
  };

  klass.$util = {
    fn: fn,
    objects: objects,
    strings: strings,
    selectors: selectors
  };

  klass.prototype.selectors = selectors;
  klass.prototype.strings = strings;
  klass.prototype.objects = objects;
  klass.prototype.fn = fn;
  klass.prototype.inViewport = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  _jquery2.default.fn[pluginName] = function PluginFactory(option) {
    return this.each(function PluginInstanceFactory() {
      var $this = (0, _jquery2.default)(this);
      var data = $this.data();
      var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
      var elementOptions = Object.keys(data).filter(function (key) {
        return (0, _strings.toCamelCase)(key).indexOf(formattedPluginName) >= ZERO;
      }).reduce(function (result, path) {
        var data = path && $this.data(path);
        var key = (0, _strings.toCamelCase)(path.replace(new RegExp(formattedPluginName + '-?'), ''));
        log(path, key, $this.data(path));

        if (key && data !== undefined) {
          result[key] = data;
        }
        return result;
      }, {});
      log(pluginName, { elementOptions: elementOptions });
      var instance = $this.data(dataName);
      var options = _jquery2.default.extend({}, klass.DEFAULTS, elementOptions, overrides);

      // store reference to instance
      if (!instance) {
        instance = new klass(this, options);
        instance.$utils = klass.$util;
        $this.data(dataName, instance);
        $this.addClass('u-' + pluginName);
      }

      // execute instance method
      if (typeof option === 'string') {
        instance[option]();
      }
    });
  };

  // - Short hand
  if (shortHand) {
    _jquery2.default[formattedPluginName] = function (options) {
      return (0, _jquery2.default)({})[formattedPluginName](options);
    };
  }

  // - No conflict
  // $.fn[formattedPluginName].noConflict = function noConflict () {
  //   $.fn[formattedPluginName] = old;
  // };
}

function jquery(name) {
  return function decorate(target) {
    plugin(name, target);
  };
}

function defaults(options) {
  return function decorate(target) {
    target.DEFAULTS = options;
  };
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementAttrtibutesToObject = elementAttrtibutesToObject;
exports.objectPath = objectPath;

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/objects';
var log = (0, _debug2.default)(MODULE_NAME);

var ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
function elementAttrtibutesToObject(element) {
  var filterFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
    return (0, _strings.toCamelCase)(name);
  };

  var output = {};
  var attrs = Array.from($(element).get(ZERO).attributes);

  if (!attrs) {
    return output;
  }

  log('converting element attributes to object', attrs);

  return attrs.reduce(function (result, attribute) {
    if (filterFn(attribute)) {
      var name = transformFn(attribute.name);
      var value = attribute.value;

      if (value === 'false' || value === 'true') {
        value = Boolean(value);
      }
      result[name] = attribute.value;
    }

    return result;
  }, output);
}

/**
 * Object.prop()
 *
 * Allows dot-notation access to object properties for both getting and setting.
 *
 * @param {Object} obj    The object we're getting from or setting
 * @param {string} prop   The dot-notated string defining the property location
 * @param {mixed}  val    For setting only; the value to set
 */

function objectPath(obj, path, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { delimiter: '.' };

  var props = path.split(options.delimiter);
  var final = props.pop();
  var part = void 0;

  for (var index = 0; index < props.length; index++) {
    part = props[index];
    if (typeof obj[part] === 'undefined') {
      // If we're setting
      if (typeof val !== 'undefined' && index != props.length) {
        // If we're not at the end of the props, keep adding new empty objects
        obj[part] = {};
      } else {
        return undefined;
      }
    }
    obj = obj[part];
  }
  return typeof val !== "undefined" ? obj[final] = val : obj[final];
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.onAvailable = exports.SELECTOR_PATTERNS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.selectorPattern = selectorPattern;
exports.selectTarget = selectTarget;
exports.onChange = onChange;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('core/plugins/lib/selectors');

function selectorPattern() {
	for (var _len = arguments.length, directives = Array(_len), _key = 0; _key < _len; _key++) {
		directives[_key] = arguments[_key];
	}

	return new RegExp('\\((' + directives.join('|') + ')(.*)\\)\\s?(.*)');
}

var SELECTOR_PATTERNS = exports.SELECTOR_PATTERNS = {

	// .find
	"children": selectorPattern('children'),

	// .closest
	"parent": selectorPattern('parent'),
	"from": selectorPattern('from'),
	"parents": selectorPattern('parents'),
	"siblings": selectorPattern('siblings'),
	"here": selectorPattern('here'),
	"self": selectorPattern('self')
};

function selectTarget(selector, $element) {
	var $target = void 0;

	var isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
	var isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
	var isRetargeted = selector.match(SELECTOR_PATTERNS.from);
	var isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
	var isGenerational = selector.match(SELECTOR_PATTERNS.here);
	var isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
	var isSelfish = selector.match(SELECTOR_PATTERNS.self);

	// special retargeting root
	if (isRetargeted) {
		log('isRetargeted', isRetargeted[2], isRetargeted[3]);
		var $newElement = selectTarget(isRetargeted[2], $element);
		var newSelector = '(children) ' + isRetargeted[3];
		log('isRetargeted.newElement', $newElement);
		log('isRetargeted.newSelector', newSelector);
		$target = selectTarget(newSelector, $newElement);
		log('isRetargeted.target', $target);
	}

	// target is all ancestors
	else if (isAllAncestoral) {
			log('isAllAncestoral', isAllAncestoral);
			$target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
		}
		// target is closest ancestor
		else if (isClosestAncestoral) {
				log('isClosestAncestoral', isClosestAncestoral);
				$target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
			}
			// target is somewhere under current parent
			else if (isGenerational) {
					log('isGenerational', isGenerational);
					$target = $element.parent().find(isGenerational[isGenerational.length - 1]);
				}
				// target is only under self
				else if (isAllDescendants) {
						log('isAllDescendants', isAllDescendants);
						$target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
					}
					// target is somewhere in siblings only
					else if (isSiblings) {
							log('isSiblings', isSiblings);
							$target = $element.siblings(isSiblings[isSiblings.length - 1]);
						}
						// target is source
						else if (!selector || isSelfish) {
								log('isSelfish', isSelfish);
								var selector = isSelfish[isSelfish.length - 1] || '*';
								$target = $element.filter(selector);
							}
							// target could be anywhere
							else {
									log('global', selector);
									$target = (0, _jquery2.default)(selector);
								}
	return $target;
}

var OnAvailable = function () {
	function OnAvailable(root) {
		_classCallCheck(this, OnAvailable);

		this.root = root || window.document.documentElement;
		this.listeners = [];
		this.observer;
	}

	_createClass(OnAvailable, [{
		key: 'ready',
		value: function ready(selector, fn) {
			// Store the selector and callback to be monitored
			this.listeners.push({
				selector: selector,
				fn: fn
			});

			if (!this.observer) {
				// Watch for changes in the document
				this.observer = onChange(this.root, this.check.bind(this), {
					childList: true,
					subtree: true
				});
			}
			// Check if the element is currently in the DOM
			this.check();
		}
	}, {
		key: 'check',
		value: function check() {
			// Check the DOM for elements matching a stored selector
			for (var i = 0, len = this.listeners.length, listener, elements; i < len; i++) {
				listener = this.listeners[i];
				// Query for elements matching the specified selector
				elements = this.root.querySelectorAll(listener.selector);
				for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
					element = elements[j];
					// Make sure the callback isn't invoked with the
					// same element more than once
					if (!element.ready) {
						element.ready = true;
						// Invoke the callback with the element
						listener.fn.call(element, element);
					}
				}
			}
		}
	}]);

	return OnAvailable;
}();

var onAvailable = exports.onAvailable = new OnAvailable(window.document.documentElement);

function onChange(element, fn, options) {
	var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	var observer = new MutationObserver(fn);
	observer.observe(element, options || {
		attributes: true,
		childList: true,
		subtree: true
	});
	return observer;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;
exports.booleanify = booleanify;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/jquery_plugin/strings');

function preserveCamelCase(str) {
  var isLastCharLower = false;
  var isLastCharUpper = false;
  var isLastLastCharUpper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = str.substr(0, i) + '-' + str.substr(i);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = str.substr(0, i - 1) + '-' + str.substr(i - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }

  return str;
}

function toCamelCase(str) {
  if (arguments.length > 1) {
    str = Array.from(arguments).map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x.length;
    }).join('-');
  } else {
    str = str.trim();
  }

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }

  var hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
    return p1.toUpperCase();
  });
};

function tmpl(str, context) {
  var result = str;

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });
  }

  return result;
}

function $tmpl(element, context) {
  var $target = (0, _jquery2.default)(element);
  var templateString = $target.attr('data-text-template');
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  log('mustache', { template: template, self: self, parent: parent, invert: invert });

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {

      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }

      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
      log('mustache.output.' + depth, { output: output });
    });
  }
  log('mustache.output', { output: output });
  return output;
}

function booleanify(value) {
  var lower = value.toLowerCase();
  if (lower === 'false' || lower === '0') {
    return false;
  }
  return new Boolean(value);
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\ga-services.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isMobile = exports.isMobile = window.innerWidth < 768;

var isOnScreen = exports.isOnScreen = function isOnScreen(el) {
	var $window = $(window);
	var viewport = {
		top: $window.scrollTop(),
		left: $window.scrollLeft()
	};
	viewport.right = viewport.left + $window.width();
	viewport.bottom = viewport.top + $window.height();
	var bounds = $(el).offset();
	bounds.right = bounds.left + $(el).outerWidth();
	bounds.bottom = bounds.top + $(el).outerHeight();
	if (bounds.left === bounds.right === 0) return false;
	return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
};

var GAServices = exports.GAServices = function () {
	function GAServices() {
		_classCallCheck(this, GAServices);
	}

	_createClass(GAServices, null, [{
		key: 'trackingGA',
		value: function trackingGA(object) {
			window.dataLayer = window.dataLayer || [];
			if (window.dataLayer !== undefined) {
				window.dataLayer.push({ ecommerce: null });
				window.dataLayer.push(object);
			}
		}
	}, {
		key: 'getAttributesWithPrefix',
		value: function getAttributesWithPrefix(element, prefix) {
			var result = {};
			$.each(element[0].attributes, function (index, attr) {
				if (attr.name.startsWith(prefix) && attr.value !== '') {
					var strippedName = attr.name.substring(prefix.length).replace(/-/g, '_');
					result[strippedName] = attr.value;
				}
			});
			return result;
		}
	}, {
		key: 'viewItemTracking',
		value: function viewItemTracking(el) {
			var isRecommend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var $el = $(el);
			var trackingItem = '[ga-tracking-item]:not(.tracked)';
			var $productList = isRecommend ? $el.find('.slide-active').find(trackingItem) : $el.find(trackingItem);
			var dataTracking = {
				event: 'view_item_list',
				ecommerce: {
					currency: $('body').data('currency'),
					items: []
				}
			};
			var items = [];
			if ($productList.length) {
				$productList.each(function (index, product) {
					if (isOnScreen(product)) {
						var $product = $(product);
						var data = GAServices.getAttributesWithPrefix($product, 'ga-');
						items.push(data);
						$product.addClass('tracked');
					}
				});
				if (items.length) {
					dataTracking.ecommerce.items = items;
					items = [];
					GAServices.trackingGA(dataTracking);
				}
			}
		}
	}, {
		key: 'selectItem',
		value: function selectItem(el) {
			var self = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			$(el).on('click', function (e) {
				var product = self ? el : el.closest('[ga-tracking-item]');
				var currency = $('body').data('currency');
				var dataTracking = {
					event: 'select_item',
					ecommerce: {
						currency: currency,
						items: []
					}
				};
				if ($(el).attr('data-trigger-quick-order')) {
					dataTracking['view_type'] = 'quickorder';
				}
				var data = GAServices.getAttributesWithPrefix($(product), 'ga-');
				if (!self) {
					var idColor = $(el).attr('data-ga-item-id');
					var variant = $(el).attr('data-ga-item-variant');
					if (idColor) data.item_id = idColor;
					if (variant) data.item_variant = variant;
				}
				dataTracking.ecommerce.items.push(data);
				GAServices.trackingGA(dataTracking);
				GAServices.saveListItemsName(dataTracking.ecommerce.items[0]);
			});
		}
	}, {
		key: 'saveListItemsName',
		value: function saveListItemsName(data) {
			var saveData = {
				item_id: data.item_id,
				index: data.index,
				item_list_name: data.item_list_name,
				list_category: data.list_category,
				list_category2: data.list_category2,
				list_category3: data.list_category3
			};
			var listItemTracking = localStorage.getItem('selectTrackingData');
			var listItems = [];
			if (listItemTracking) {
				listItems = JSON.parse(listItemTracking);
			}
			if (listItems.length) {
				var index = listItems.map(function (item) {
					return item.item_id;
				}).indexOf(data.item_id);
				if (index > -1) {
					listItems.splice(index, 1);
				}
			}
			listItems.push(saveData);
			localStorage.setItem('selectTrackingData', JSON.stringify(listItems));
		}
	}, {
		key: 'getItemListName',
		value: function getItemListName(id) {
			var item = {
				item_id: id
			};
			var listItemTracking = localStorage.getItem('selectTrackingData');
			var listItems = [];
			if (listItemTracking) {
				listItems = JSON.parse(listItemTracking);
				var temp = listItems.filter(function (item) {
					return item.item_id === id;
				})[0];
				if (temp) item = temp;
			}
			return item;
		}
	}, {
		key: 'filterEmptyData',
		value: function filterEmptyData(item) {
			return Object.keys(item).reduce(function (_result, _current) {
				var value = item[_current];
				if (value !== '') {
					_result[_current] = value;
				}
				return _result;
			}, {});
		}
	}, {
		key: 'addGAForSearchAutoComplete',
		value: function addGAForSearchAutoComplete(string, results) {
			var parser = new DOMParser();
			var doc = parser.parseFromString(string, "text/html");
			var items = doc.body.firstChild.querySelectorAll('.search-dropdown__result-item');
			items.forEach(function (item, index) {
				var datalayer = results[index].Datalayer;
				if (datalayer) {
					item.setAttribute('ga-tracking-item', '');
					item.setAttribute('ga-tracking-link', '');
					Object.keys(datalayer).forEach(function (key) {
						item.setAttribute('ga-' + key.replace(/_/g, '-'), datalayer[key]);
					});
					item.setAttribute('ga-item-list-name', 'Search Suggestion');
					item.setAttribute('ga-index', index + 1);
					item.removeAttribute('ga-quantity');
					item.removeAttribute('ga-list-category');
					item.removeAttribute('ga-list-category2');
					item.removeAttribute('ga-list-category3');
				}
			});
			return doc.body.innerHTML;
		}
	}, {
		key: 'getDataLayer',
		value: function getDataLayer($product, attr) {
			var data = [];
			$product.forEach(function (item, index) {
				var $dataItem = item.getAttribute(attr);
				if (!$dataItem) return;
				var _datalayer = JSON.parse($dataItem);
				var dataItemList = GAServices.getItemListName(_datalayer.item_id);
				if (dataItemList.item_list_name === 'Search Suggestion') {
					dataItemList.list_category = undefined;
					dataItemList.list_category2 = undefined;
					dataItemList.list_category3 = undefined;
				}
				var product = Object.assign({}, _datalayer, dataItemList);
				if (!product.status) {
					delete product.status;
				}
				data.push(GAServices.filterEmptyData(product));
			});
			return data;
		}
	}, {
		key: 'sendPaymentInfo',
		value: function sendPaymentInfo() {
			var value = document.querySelector('[data-sub-total]') && document.querySelector('[data-sub-total]').dataset.subTotal ? document.querySelector('[data-sub-total]').dataset.subTotal.replace('$', '') : undefined;
			var payment = '';
			var $paymentList = document.querySelectorAll('[name="paymentMethod"]');
			if ($paymentList.length > 1) {
				payment = Array.from($paymentList).filter(function (item) {
					return item.checked;
				})[0].dataset.gaName;
			} else if ($paymentList.length === 1) {
				payment = $paymentList[0].dataset.gaName;
			} else {
				return;
			}
			var count = document.querySelector('.order-summary').dataset.trackingCount;
			var data = JSON.parse(localStorage.getItem('cartTrackingData')) || [];
			// Check promo code at step payment
			var $orderedItems = document.querySelectorAll('.cart-item');
			if ($orderedItems.length) {
				data = GAServices.getDataLayer($orderedItems, 'data-item-datalayer');
				localStorage.setItem('cartTrackingData', JSON.stringify(data));
			}
			var dataTracking = {
				event: 'add_payment_info',
				ecommerce: {
					currency: $('body').data('currency'),
					value: value,
					item_count: count,
					payment_type: payment,
					items: data
				}
			};
			GAServices.trackingGA(dataTracking);
			localStorage.removeItem('orderIdTracking');
		}
	}]);

	return GAServices;
}();

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\klaviyo-services.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KlaviyoServices = exports.KlaviyoServices = function () {
	function KlaviyoServices() {
		_classCallCheck(this, KlaviyoServices);
	}

	_createClass(KlaviyoServices, null, [{
		key: "trackingKlaviyo",
		value: function trackingKlaviyo(eventName, data) {
			if (window.klaviyo && !!data) {
				window.klaviyo.track(eventName, data);
			}
		}
	}, {
		key: "trackViewedItem",
		value: function trackViewedItem(data) {
			if (window.klaviyo && !!data) {
				var trackedViewedData = Object.assign({}, {
					"Title": data.title,
					"ItemId": data.id,
					"SKU": data.sku,
					"Categories": data.categories ? data.categories.split(',').filter(function (item) {
						return item.trim() !== '';
					}) : [],
					"ImageUrl": data.image_link,
					"Url": data.link,
					"Metadata": {
						"Brand": data.brand,
						"Price": data.price,
						"CompareAtPrice": null
					}
				});

				window.klaviyo.trackViewedItem(trackedViewedData);
			}
		}
	}, {
		key: "filterEmptyData",
		value: function filterEmptyData(item) {
			return Object.keys(item).reduce(function (_result, _current) {
				var value = item[_current];
				if (value !== '') {
					_result[_current] = value;
				}
				return _result;
			}, {});
		}
	}, {
		key: "getTotalCartValue",
		value: function getTotalCartValue(carts) {
			var totalCartPrice = carts.reduce(function (total, product) {
				var price = product.sale_price > 0 ? product.sale_price : product.price;
				return total + price * product.quantity;
			}, 0);

			return Math.round(totalCartPrice * 100) / 100;
		}
	}, {
		key: "getTotalQuantity",
		value: function getTotalQuantity(carts) {
			return carts.reduce(function (sum, product) {
				var qty = Number(product.quantity);
				return sum + (isNaN(qty) ? 0 : qty);
			}, 0);
		}
	}, {
		key: "getDataLayer",
		value: function getDataLayer($product, attr) {
			var data = [];
			if (!!$product) {
				$product.forEach(function (item, index) {
					var $dataItem = item.getAttribute(attr);
					if (!$dataItem) return;
					var _datalayer = JSON.parse($dataItem);
					data.push(KlaviyoServices.filterEmptyData(_datalayer));
				});
			}

			return data;
		}
	}, {
		key: "convertToNumber",
		value: function convertToNumber(numberString) {
			Number.parseFloat(numberString.replace(/,/g, ''));
		}
	}, {
		key: "sortProductsByQuantity",
		value: function sortProductsByQuantity(products) {
			return products.sort(function (a, b) {
				return b.quantity - a.quantity;
			});
		}
	}]);

	return KlaviyoServices;
}();

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\vendor\\modaal\\modaal.min@0.4.4.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
	Modaal - accessible modals - v0.4.4
	by Humaan, for all humans.
	http://humaan.com
 */
!function (a) {
	function t(a) {
		var t = {},
		    o = !1;a.attr("data-modaal-type") && (o = !0, t.type = a.attr("data-modaal-type")), a.attr("data-modaal-content-source") && (o = !0, t.content_source = a.attr("data-modaal-content-source")), a.attr("data-modaal-animation") && (o = !0, t.animation = a.attr("data-modaal-animation")), a.attr("data-modaal-animation-speed") && (o = !0, t.animation_speed = a.attr("data-modaal-animation-speed")), a.attr("data-modaal-after-callback-delay") && (o = !0, t.after_callback_delay = a.attr("data-modaal-after-callback-delay")), a.attr("data-modaal-is-locked") && (o = !0, t.is_locked = "true" === a.attr("data-modaal-is-locked")), a.attr("data-modaal-hide-close") && (o = !0, t.hide_close = "true" === a.attr("data-modaal-hide-close")), a.attr("data-modaal-background") && (o = !0, t.background = a.attr("data-modaal-background")), a.attr("data-modaal-overlay-opacity") && (o = !0, t.overlay_opacity = a.attr("data-modaal-overlay-opacity")), a.attr("data-modaal-overlay-close") && (o = !0, t.overlay_close = "false" !== a.attr("data-modaal-overlay-close")), a.attr("data-modaal-accessible-title") && (o = !0, t.accessible_title = a.attr("data-modaal-accessible-title")), a.attr("data-modaal-start-open") && (o = !0, t.start_open = "true" === a.attr("data-modaal-start-open")), a.attr("data-modaal-fullscreen") && (o = !0, t.fullscreen = "true" === a.attr("data-modaal-fullscreen")), a.attr("data-modaal-custom-class") && (o = !0, t.custom_class = a.attr("data-modaal-custom-class")), a.attr("data-modaal-close-text") && (o = !0, t.close_text = a.attr("data-modaal-close-text")), a.attr("data-modaal-close-aria-label") && (o = !0, t.close_aria_label = a.attr("data-modaal-close-aria-label")), a.attr("data-modaal-background-scroll") && (o = !0, t.background_scroll = "true" === a.attr("data-modaal-background-scroll")), a.attr("data-modaal-width") && (o = !0, t.width = parseInt(a.attr("data-modaal-width"))), a.attr("data-modaal-height") && (o = !0, t.height = parseInt(a.attr("data-modaal-height"))), a.attr("data-modaal-confirm-button-text") && (o = !0, t.confirm_button_text = a.attr("data-modaal-confirm-button-text")), a.attr("data-modaal-confirm-cancel-button-text") && (o = !0, t.confirm_cancel_button_text = a.attr("data-modaal-confirm-cancel-button-text")), a.attr("data-modaal-confirm-title") && (o = !0, t.confirm_title = a.attr("data-modaal-confirm-title")), a.attr("data-modaal-confirm-content") && (o = !0, t.confirm_content = a.attr("data-modaal-confirm-content")), a.attr("data-modaal-gallery-active-class") && (o = !0, t.gallery_active_class = a.attr("data-modaal-gallery-active-class")), a.attr("data-modaal-loading-content") && (o = !0, t.loading_content = a.attr("data-modaal-loading-content")), a.attr("data-modaal-loading-class") && (o = !0, t.loading_class = a.attr("data-modaal-loading-class")), a.attr("data-modaal-ajax-error-class") && (o = !0, t.ajax_error_class = a.attr("data-modaal-ajax-error-class")), a.attr("data-modaal-instagram-id") && (o = !0, t.instagram_id = a.attr("data-modaal-instagram-id")), o && a.modaal(t);
	}var o = { init: function init(t, o) {
			var e = this;if (e.dom = a("body"), e.$elem = a(o), e.options = a.extend({}, a.fn.modaal.options, e.$elem.data(), t), e.xhr = null, e.scope = { is_open: !1, id: "modaal_" + new Date().getTime() + Math.random().toString(16).substring(2), source: e.options.content_source ? e.options.content_source : e.$elem.attr("href") }, e.$elem.attr("data-modaal-scope", e.scope.id), e.private_options = { active_class: "is_active" }, e.lastFocus = null, e.options.is_locked || "confirm" == e.options.type || e.options.hide_close ? e.scope.close_btn = "" : e.scope.close_btn = '<button type="button" class="modaal-close" id="modaal-close" aria-label="' + e.options.close_aria_label + '"><span>' + e.options.close_text + "</span></button>", "none" === e.options.animation && (e.options.animation_speed = 0, e.options.after_callback_delay = 0), a(o).on("click.Modaal", function (a) {
				a.preventDefault(), e.create_modaal(e, a);
			}), !0 === e.options.outer_controls) var i = "outer";else var i = "inner";e.scope.prev_btn = '<button type="button" class="modaal-gallery-control modaal-gallery-prev modaal-gallery-prev-' + i + '" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>', e.scope.next_btn = '<button type="button" class="modaal-gallery-control modaal-gallery-next modaal-gallery-next-' + i + '" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>', !0 === e.options.start_open && e.create_modaal(e);
		}, create_modaal: function create_modaal(a, t) {
			var o,
			    a = this;if (a.lastFocus = a.$elem, !1 !== a.options.should_open && ("function" != typeof a.options.should_open || !1 !== a.options.should_open())) {
				switch (a.options.before_open.call(a, t), a.options.type) {case "inline":
						a.create_basic();break;case "ajax":
						o = a.options.source(a.$elem, a.scope.source), a.fetch_ajax(o);break;case "confirm":
						a.options.is_locked = !0, a.create_confirm();break;case "image":
						a.create_image();break;case "iframe":
						o = a.options.source(a.$elem, a.scope.source), a.create_iframe(o);break;case "video":
						a.create_video(a.scope.source);break;case "instagram":
						a.create_instagram();}a.watch_events();
			}
		}, watch_events: function watch_events() {
			var t = this;t.dom.off("click.Modaal keyup.Modaal keydown.Modaal"), t.dom.on("keydown.Modaal", function (o) {
				var e = o.keyCode,
				    i = o.target;9 == e && t.scope.is_open && (a.contains(document.getElementById(t.scope.id), i) || a("#" + t.scope.id).find('*[tabindex="0"]').focus());
			}), t.dom.on("keyup.Modaal", function (o) {
				var e = o.keyCode,
				    i = o.target;return o.shiftKey && 9 == o.keyCode && t.scope.is_open && (a.contains(document.getElementById(t.scope.id), i) || a("#" + t.scope.id).find(".modaal-close").focus()), !t.options.is_locked && 27 == e && t.scope.is_open ? !a(document.activeElement).is("input:not(:checkbox):not(:radio)") && void t.modaal_close() : "image" == t.options.type ? (37 == e && t.scope.is_open && !a("#" + t.scope.id + " .modaal-gallery-prev").hasClass("is_hidden") && t.gallery_update("prev"), void (39 == e && t.scope.is_open && !a("#" + t.scope.id + " .modaal-gallery-next").hasClass("is_hidden") && t.gallery_update("next"))) : void 0;
			}), t.dom.on("click.Modaal", function (o) {
				var e = a(o.target);if (!t.options.is_locked && (t.options.overlay_close && e.is(".modaal-inner-wrapper") || e.is(".modaal-close") || e.closest(".modaal-close").length)) return void t.modaal_close();if (e.is(".modaal-confirm-btn")) return e.is(".modaal-ok") && t.options.confirm_callback.call(t, t.lastFocus), e.is(".modaal-cancel") && t.options.confirm_cancel_callback.call(t, t.lastFocus), void t.modaal_close();if (e.is(".modaal-gallery-control")) {
					if (e.hasClass("is_hidden")) return;return e.is(".modaal-gallery-prev") && t.gallery_update("prev"), void (e.is(".modaal-gallery-next") && t.gallery_update("next"));
				}
			});
		}, build_modal: function build_modal(t) {
			var o = this,
			    e = "";"instagram" == o.options.type && (e = " modaal-instagram");var i,
			    l = "video" == o.options.type ? "modaal-video-wrap" : "modaal-content";switch (o.options.animation) {case "fade":
					i = " modaal-start_fade";break;case "slide-down":
					i = " modaal-start_slidedown";break;default:
					i = " modaal-start_none";}var n = "";o.options.fullscreen && (n = " modaal-fullscreen"), "" === o.options.custom_class && void 0 === o.options.custom_class || (o.options.custom_class = " " + o.options.custom_class);var s = "";o.options.width && o.options.height && "number" == typeof o.options.width && "number" == typeof o.options.height ? s = ' style="max-width:' + o.options.width + "px;height:" + o.options.height + 'px;overflow:auto;"' : o.options.width && "number" == typeof o.options.width ? s = ' style="max-width:' + o.options.width + 'px;"' : o.options.height && "number" == typeof o.options.height && (s = ' style="height:' + o.options.height + 'px;overflow:auto;"'), ("image" == o.options.type || "video" == o.options.type || "instagram" == o.options.type || o.options.fullscreen) && (s = "");var d = "";o.is_touch() && (d = ' style="cursor:pointer;"');var r = '<div class="modaal-wrapper modaal-' + o.options.type + i + e + n + o.options.custom_class + '" id="' + o.scope.id + '"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper"' + d + ">";"video" != o.options.type && (r += '<div class="modaal-container"' + s + ">"), r += '<div class="' + l + ' modaal-focus" aria-hidden="false" aria-label="' + o.options.accessible_title + " - " + o.options.close_aria_label + '" role="dialog">', "inline" == o.options.type ? r += '<div class="modaal-content-container" role="document"></div>' : r += t, r += "</div>" + o.scope.close_btn, "video" != o.options.type && (r += "</div>"), r += "</div>", "image" == o.options.type && !0 === o.options.outer_controls && (r += o.scope.prev_btn + o.scope.next_btn), r += "</div></div>", a("#" + o.scope.id + "_overlay").length < 1 && o.dom.append(r), "inline" == o.options.type && t.appendTo("#" + o.scope.id + " .modaal-content-container"), o.modaal_overlay("show");
		}, create_basic: function create_basic() {
			var t = this,
			    o = a(t.scope.source),
			    e = "";o.length ? (e = o.contents().detach(), o.empty()) : e = "Content could not be loaded. Please check the source and try again.", t.build_modal(e);
		}, create_instagram: function create_instagram() {
			var t = this,
			    o = t.options.instagram_id,
			    e = "",
			    i = "Instagram photo couldn't be loaded, please check the embed code and try again.";if (t.build_modal('<div class="modaal-content-container' + ("" != t.options.loading_class ? " " + t.options.loading_class : "") + '">' + t.options.loading_content + "</div>"), "" != o && null !== o && void 0 !== o) {
				var l = "https://api.instagram.com/oembed?url=http://instagr.am/p/" + o + "/";a.ajax({ url: l, dataType: "jsonp", cache: !1, success: function success(o) {
						t.dom.append('<div id="temp-ig" style="width:0;height:0;overflow:hidden;">' + o.html + "</div>"), t.dom.attr("data-igloaded") ? window.instgrm.Embeds.process() : t.dom.attr("data-igloaded", "true");var e = "#" + t.scope.id + " .modaal-content-container";a(e).length > 0 && setTimeout(function () {
							a("#temp-ig").contents().clone().appendTo(e), a("#temp-ig").remove();
						}, 1e3);
					}, error: function error() {
						e = i;var o = a("#" + t.scope.id + " .modaal-content-container");o.length > 0 && (o.removeClass(t.options.loading_class).addClass(t.options.ajax_error_class), o.html(e));
					} });
			} else e = i;return !1;
		}, fetch_ajax: function fetch_ajax(t) {
			var o = this;null == o.options.accessible_title && (o.options.accessible_title = "Dialog Window"), null !== o.xhr && (o.xhr.abort(), o.xhr = null), o.build_modal('<div class="modaal-content-container' + ("" != o.options.loading_class ? " " + o.options.loading_class : "") + '">' + o.options.loading_content + "</div>"), o.xhr = a.ajax(t, { success: function success(t) {
					var e = a("#" + o.scope.id).find(".modaal-content-container");e.length > 0 && (e.removeClass(o.options.loading_class), e.html(t), o.options.ajax_success.call(o, e));
				}, error: function error(t) {
					if ("abort" != t.statusText) {
						var e = a("#" + o.scope.id + " .modaal-content-container");e.length > 0 && (e.removeClass(o.options.loading_class).addClass(o.options.ajax_error_class), e.html("Content could not be loaded. Please check the source and try again."));
					}
				} });
		}, create_confirm: function create_confirm() {
			var a,
			    t = this;a = '<div class="modaal-content-container"><h1 id="modaal-title">' + t.options.confirm_title + '</h1><div class="modaal-confirm-content">' + t.options.confirm_content + '</div><div class="modaal-confirm-wrap"><button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">' + t.options.confirm_button_text + '</button><button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">' + t.options.confirm_cancel_button_text + "</button></div></div></div>", t.build_modal(a);
		}, create_image: function create_image() {
			var t,
			    o,
			    e = this,
			    i = "";if (e.$elem.is("[data-group]") || e.$elem.is("[rel]")) {
				var l = e.$elem.is("[data-group]"),
				    n = l ? e.$elem.attr("data-group") : e.$elem.attr("rel"),
				    s = a(l ? '[data-group="' + n + '"]' : '[rel="' + n + '"]');s.removeAttr("data-gallery-active", "is_active"), e.$elem.attr("data-gallery-active", "is_active"), o = s.length - 1;var d = [];i = '<div class="modaal-gallery-item-wrap">', s.each(function (t, o) {
					var e = "",
					    i = "",
					    l = "",
					    n = !1,
					    s = !1,
					    r = o.getAttribute("data-modaal-desc"),
					    c = o.getAttribute("data-gallery-active");a(o).attr("data-modaal-content-source") ? e = a(o).attr("data-modaal-content-source") : a(o).attr("href") ? e = a(o).attr("href") : a(o).attr("src") ? e = a(o).attr("src") : (e = "trigger requires href or data-modaal-content-source attribute", s = !0), "" != r && null !== r && void 0 !== r ? (i = r, l = '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' + (t + 1) + " - </span>" + r.replace(/</g, "&lt;").replace(/>/g, "&gt;") + "</div>") : l = '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' + (t + 1) + "</span></div>", c && (n = !0);var m = { url: e, alt: i, rawdesc: r, desc: l, active: n, src_error: s };d.push(m);
				});for (var r = 0; r < d.length; r++) {
					var c = "",
					    m = d[r].rawdesc ? "Image: " + d[r].rawdesc : "Image " + r + " no description";d[r].active && (c = " " + e.private_options.active_class);var p = d[r].src_error ? d[r].url : '<img src="' + d[r].url + '" alt=" " style="width:100%">';i += '<div class="modaal-gallery-item gallery-item-' + r + c + '" aria-label="' + m + '">' + p + d[r].desc + "</div>";
				}i += "</div>", 1 != e.options.outer_controls && (i += e.scope.prev_btn + e.scope.next_btn);
			} else {
				var u,
				    _ = !1;e.$elem.attr("data-modaal-content-source") ? u = e.$elem.attr("data-modaal-content-source") : e.$elem.attr("href") ? u = e.$elem.attr("href") : e.$elem.attr("src") ? u = e.$elem.attr("src") : (u = "trigger requires href or data-modaal-content-source attribute", _ = !0);var v = "",
				    f = "",
				    m = "";e.$elem.attr("data-modaal-desc") ? (m = e.$elem.attr("data-modaal-desc"), v = e.$elem.attr("data-modaal-desc"), f = '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>' + v.replace(/</g, "&lt;").replace(/>/g, "&gt;") + "</div>") : m = "Image with no description";var p = _ ? u : '<img src="' + u + '" alt=" " style="width:100%">';i = '<div class="modaal-gallery-item is_active" aria-label="' + m + '">' + p + f + "</div>";
			}t = i, e.build_modal(t), a(".modaal-gallery-item.is_active").is(".gallery-item-0") && a(".modaal-gallery-prev").hide(), a(".modaal-gallery-item.is_active").is(".gallery-item-" + o) && a(".modaal-gallery-next").hide();
		}, gallery_update: function gallery_update(t) {
			var o = this,
			    e = a("#" + o.scope.id),
			    i = e.find(".modaal-gallery-item"),
			    l = i.length - 1;if (0 == l) return !1;var n = e.find(".modaal-gallery-prev"),
			    s = e.find(".modaal-gallery-next"),
			    d = 0,
			    r = 0,
			    c = e.find(".modaal-gallery-item." + o.private_options.active_class),
			    m = "next" == t ? c.next(".modaal-gallery-item") : c.prev(".modaal-gallery-item");return o.options.before_image_change.call(o, c, m), ("prev" != t || !e.find(".gallery-item-0").hasClass("is_active")) && ("next" != t || !e.find(".gallery-item-" + l).hasClass("is_active")) && void c.stop().animate({ opacity: 0 }, 250, function () {
				m.addClass("is_next").css({ position: "absolute", display: "block", opacity: 0 });var t = a(document).width(),
				    i = t > 1140 ? 280 : 50;d = e.find(".modaal-gallery-item.is_next").width(), r = e.find(".modaal-gallery-item.is_next").height();var p = e.find(".modaal-gallery-item.is_next img").prop("naturalWidth"),
				    u = e.find(".modaal-gallery-item.is_next img").prop("naturalHeight");p > t - i ? (d = t - i, e.find(".modaal-gallery-item.is_next").css({ width: d }), e.find(".modaal-gallery-item.is_next img").css({ width: d }), r = e.find(".modaal-gallery-item.is_next").find("img").height()) : (d = p, r = u), e.find(".modaal-gallery-item-wrap").stop().animate({ width: d, height: r }, 250, function () {
					c.removeClass(o.private_options.active_class + " " + o.options.gallery_active_class).removeAttr("style"), c.find("img").removeAttr("style"), m.addClass(o.private_options.active_class + " " + o.options.gallery_active_class).removeClass("is_next").css("position", ""), m.stop().animate({ opacity: 1 }, 250, function () {
						a(this).removeAttr("style").css({ width: "100%" }), a(this).find("img").css("width", "100%"), e.find(".modaal-gallery-item-wrap").removeAttr("style"), o.options.after_image_change.call(o, m);
					}), e.find(".modaal-gallery-item").removeAttr("tabindex"), e.find(".modaal-gallery-item." + o.private_options.active_class).attr("tabindex", "0").focus(), e.find(".modaal-gallery-item." + o.private_options.active_class).is(".gallery-item-0") ? n.stop().animate({ opacity: 0 }, 150, function () {
						a(this).hide();
					}) : n.stop().css({ display: "block", opacity: n.css("opacity") }).animate({ opacity: 1 }, 150), e.find(".modaal-gallery-item." + o.private_options.active_class).is(".gallery-item-" + l) ? s.stop().animate({ opacity: 0 }, 150, function () {
						a(this).hide();
					}) : s.stop().css({ display: "block", opacity: n.css("opacity") }).animate({ opacity: 1 }, 150);
				});
			});
		}, create_video: function create_video(a) {
			var t,
			    o = this;t = '<iframe src="' + a + '" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>', o.build_modal('<div class="modaal-video-container">' + t + "</div>");
		}, create_iframe: function create_iframe(a) {
			var t,
			    o = this;t = null !== o.options.width || void 0 !== o.options.width || null !== o.options.height || void 0 !== o.options.height ? '<iframe src="' + a + '" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>' : '<div class="modaal-content-container">Please specify a width and height for your iframe</div>', o.build_modal(t);
		}, modaal_open: function modaal_open() {
			var t = this,
			    o = a("#" + t.scope.id),
			    e = t.options.animation;"none" === e && (o.removeClass("modaal-start_none"), t.options.after_open.call(t, o)), "fade" === e && o.removeClass("modaal-start_fade"), "slide-down" === e && o.removeClass("modaal-start_slide_down");var i = o;a(".modaal-wrapper *[tabindex=0]").removeAttr("tabindex"), i = "image" == t.options.type ? a("#" + t.scope.id).find(".modaal-gallery-item." + t.private_options.active_class) : o.find(".modaal-iframe-elem").length ? o.find(".modaal-iframe-elem") : o.find(".modaal-video-wrap").length ? o.find(".modaal-video-wrap") : o.find(".modaal-focus"), i.attr("tabindex", "0").focus(), "none" !== e && setTimeout(function () {
				t.options.after_open.call(t, o);
			}, t.options.after_callback_delay);
		}, modaal_close: function modaal_close() {
			var t = this,
			    o = a("#" + t.scope.id);t.options.before_close.call(t, o), null !== t.xhr && (t.xhr.abort(), t.xhr = null), "none" === t.options.animation && o.addClass("modaal-start_none"), "fade" === t.options.animation && o.addClass("modaal-start_fade"), "slide-down" === t.options.animation && o.addClass("modaal-start_slide_down"), setTimeout(function () {
				"inline" == t.options.type && a("#" + t.scope.id + " .modaal-content-container").contents().detach().appendTo(t.scope.source), o.remove(), t.options.after_close.call(t), t.scope.is_open = !1;
			}, t.options.after_callback_delay), t.modaal_overlay("hide"), null != t.lastFocus && t.lastFocus.focus();
		}, modaal_overlay: function modaal_overlay(t) {
			var o = this;"show" == t ? (o.scope.is_open = !0, o.options.background_scroll || o.dom.addClass("modaal-noscroll"), a("#" + o.scope.id + "_overlay").length < 1 && o.dom.append('<div class="modaal-overlay" id="' + o.scope.id + '_overlay"></div>'), a("#" + o.scope.id + "_overlay").css("background", o.options.background).stop().animate({ opacity: o.options.overlay_opacity }, o.options.animation_speed, function () {
				o.modaal_open();
			})) : "hide" == t && a("#" + o.scope.id + "_overlay").stop().animate({ opacity: 0 }, o.options.animation_speed, function () {
				a(this).remove(), o.dom.removeClass("modaal-noscroll");
			});
		}, is_touch: function is_touch() {
			return "ontouchstart" in window || navigator.maxTouchPoints;
		} },
	    e = [];a.fn.modaal = function (t) {
		return this.each(function (i) {
			var l = a(this).data("modaal");if (l) {
				if ("string" == typeof t) switch (t) {case "open":
						l.create_modaal(l);break;case "close":
						l.modaal_close();}
			} else {
				var n = Object.create(o);n.init(t, this), a.data(this, "modaal", n), e.push({ element: a(this).attr("class"), options: t });
			}
		});
	}, a.fn.modaal.options = { type: "inline", content_source: null, animation: "fade", animation_speed: 300, after_callback_delay: 350, is_locked: !1, hide_close: !1, background: "#000", overlay_opacity: "0.8", overlay_close: !0, accessible_title: "Dialog Window", start_open: !1, fullscreen: !1, custom_class: "", background_scroll: !1, should_open: !0, close_text: "Close", close_aria_label: "Close (Press escape to close)", width: null, height: null, before_open: function before_open() {}, after_open: function after_open() {}, before_close: function before_close() {}, after_close: function after_close() {}, source: function source(a, t) {
			return t;
		}, confirm_button_text: "Confirm", confirm_cancel_button_text: "Cancel", confirm_title: "Confirm Title", confirm_content: "<p>This is the default confirm dialog content. Replace me through the options</p>", confirm_callback: function confirm_callback() {}, confirm_cancel_callback: function confirm_cancel_callback() {}, gallery_active_class: "gallery_active_item", outer_controls: !1, before_image_change: function before_image_change(a, t) {}, after_image_change: function after_image_change(a) {}, loading_content: '<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>', loading_class: "is_loading", ajax_error_class: "modaal-error", ajax_success: function ajax_success() {}, instagram_id: null }, a(function () {
		var o = a(".modaal");o.length && o.each(function () {
			t(a(this));
		});var i = new MutationObserver(function (o) {
			o.forEach(function (o) {
				if (o.addedNodes && o.addedNodes.length > 0) {
					[].some.call(o.addedNodes, function (o) {
						var i = a(o);(i.is("a") || i.is("button")) && (i.hasClass("modaal") ? t(i) : e.forEach(function (t) {
							if (t.element == i.attr("class")) return a(i).modaal(t.options), !1;
						}));
					});
				}
			});
		}),
		    l = { subtree: !0, attributes: !0, childList: !0, characterData: !0 };setTimeout(function () {
			i.observe(document.body, l);
		}, 500);
	});
}(jQuery, window, document);

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var mapsKeyElement = document.querySelector('meta[name="config:keys.google-maps"]');
var googleApiKey = mapsKeyElement ? mapsKeyElement.content : undefined;

/**
 * Google API Key
 * @type {string}
 */
var GOOGLE_API_KEY = exports.GOOGLE_API_KEY = googleApiKey;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\google-maps-api-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _urlBuilder = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\lib\\url-builder.js");

var _urlBuilder2 = _interopRequireDefault(_urlBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var googleApi;

function loadAutoCompleteAPI(params) {
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.src = (0, _urlBuilder2.default)({
		base: "https://maps.googleapis.com/maps/api/js",
		libraries: params.libraries || [],
		callback: "googleMapsAutoCompleteAPILoad",
		apiKey: params.apiKey,
		client: params.client
	});

	document.querySelector("head").appendChild(script);
}

/**
 * googleMapsApiLoader
 *
 * @param  {object} params
 * @param  {object} params.libraries
 *
 * @return {promise}
 */
function googleMapsApiLoader(params) {
	if (googleApi) {
		return Promise.resolve(googleApi);
	}

	var windowRef = window || {};

	var deferred = function deferred(resolve, reject) {
		loadAutoCompleteAPI(params);

		windowRef.googleMapsAutoCompleteAPILoad = function () {
			googleApi = windowRef.google;
			resolve(googleApi);
		};

		setTimeout(function () {
			if (!windowRef.google) {
				reject(new Error("Loading took too long."));
			}
		}, 5000);
	};

	return new Promise(deferred);
}

exports.default = googleMapsApiLoader;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _googleMapsApiLoader = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\google-maps-api-loader.js");

var _googleMapsApiLoader2 = _interopRequireDefault(_googleMapsApiLoader);

var _config = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\config.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)("google-maps-api");

//
// Dependencies
//
// Utilities


//
// Config
var GOOGLE_API_OPTIONS = {
  libraries: ['places'],
  apiKey: _config.GOOGLE_API_KEY
};

//
// Exports
/**
 * @type {Promise.<google>}
 */
exports.default = (0, _googleMapsApiLoader2.default)(GOOGLE_API_OPTIONS);

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\vendor\\google-maps-api\\lib\\url-builder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * urlBuilder
 *
 * @param  {object} params
 * @param  {string} params.base       the base url
 * @param  {array}  params.libraries  an array of the libraries to be requested
 * @param  {string} params.callback   the callback function
 *
 * @return {string}
 */

function urlBuilder(params) {
  var builtUrl = params.base;

  builtUrl += '?';

  if (params.apiKey) {
    builtUrl += 'key=' + params.apiKey + '&';
  }

  if (params.client) {
    builtUrl += 'client=' + params.client + '&';
  }

  if (params.libraries.length > 0) {
    builtUrl += 'libraries=';

    params.libraries.forEach(function (library, index) {
      builtUrl += library;

      if (index !== params.libraries.length - 1) {
        builtUrl += ',';
      }
    });

    builtUrl += '&';
  }

  builtUrl += 'callback=' + params.callback;

  return builtUrl;
}

module.exports = urlBuilder;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\node_modules\\ms\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\common.js")(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\process\\browser.js")))

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\common.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\node_modules\\ms\\index.js");
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */

  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */

  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */

  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */

  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\es6-promise\\dist\\es6-promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {var require;var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
 * @version   2.3.0
 */

(function () {
  "use strict";

  function lib$es6$promise$utils$$objectOrFunction(x) {
    return typeof x === 'function' || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
  }

  function lib$es6$promise$utils$$isFunction(x) {
    return typeof x === 'function';
  }

  function lib$es6$promise$utils$$isMaybeThenable(x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
  }

  var lib$es6$promise$utils$$_isArray;
  if (!Array.isArray) {
    lib$es6$promise$utils$$_isArray = function lib$es6$promise$utils$$_isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  } else {
    lib$es6$promise$utils$$_isArray = Array.isArray;
  }

  var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
  var lib$es6$promise$asap$$len = 0;
  var lib$es6$promise$asap$$toString = {}.toString;
  var lib$es6$promise$asap$$vertxNext;
  var lib$es6$promise$asap$$customSchedulerFn;

  var lib$es6$promise$asap$$asap = function asap(callback, arg) {
    lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
    lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
    lib$es6$promise$asap$$len += 2;
    if (lib$es6$promise$asap$$len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (lib$es6$promise$asap$$customSchedulerFn) {
        lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
      } else {
        lib$es6$promise$asap$$scheduleFlush();
      }
    }
  };

  function lib$es6$promise$asap$$setScheduler(scheduleFn) {
    lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
  }

  function lib$es6$promise$asap$$setAsap(asapFn) {
    lib$es6$promise$asap$$asap = asapFn;
  }

  var lib$es6$promise$asap$$browserWindow = typeof window !== 'undefined' ? window : undefined;
  var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
  var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
  var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

  // test for web worker but not in IE10
  var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

  // node
  function lib$es6$promise$asap$$useNextTick() {
    var nextTick = process.nextTick;
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // setImmediate should be used instead instead
    var version = process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
    if (Array.isArray(version) && version[1] === '0' && version[2] === '10') {
      nextTick = setImmediate;
    }
    return function () {
      nextTick(lib$es6$promise$asap$$flush);
    };
  }

  // vertx
  function lib$es6$promise$asap$$useVertxTimer() {
    return function () {
      lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
    };
  }

  function lib$es6$promise$asap$$useMutationObserver() {
    var iterations = 0;
    var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
    var node = document.createTextNode('');
    observer.observe(node, { characterData: true });

    return function () {
      node.data = iterations = ++iterations % 2;
    };
  }

  // web worker
  function lib$es6$promise$asap$$useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = lib$es6$promise$asap$$flush;
    return function () {
      channel.port2.postMessage(0);
    };
  }

  function lib$es6$promise$asap$$useSetTimeout() {
    return function () {
      setTimeout(lib$es6$promise$asap$$flush, 1);
    };
  }

  var lib$es6$promise$asap$$queue = new Array(1000);
  function lib$es6$promise$asap$$flush() {
    for (var i = 0; i < lib$es6$promise$asap$$len; i += 2) {
      var callback = lib$es6$promise$asap$$queue[i];
      var arg = lib$es6$promise$asap$$queue[i + 1];

      callback(arg);

      lib$es6$promise$asap$$queue[i] = undefined;
      lib$es6$promise$asap$$queue[i + 1] = undefined;
    }

    lib$es6$promise$asap$$len = 0;
  }

  function lib$es6$promise$asap$$attemptVertex() {
    try {
      var r = require;
      var vertx = __webpack_require__("ignored D:\\a\\1\\s\\node_modules\\es6-promise\\dist vertx");
      lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return lib$es6$promise$asap$$useVertxTimer();
    } catch (e) {
      return lib$es6$promise$asap$$useSetTimeout();
    }
  }

  var lib$es6$promise$asap$$scheduleFlush;
  // Decide what async method to use to triggering processing of queued callbacks:
  if (lib$es6$promise$asap$$isNode) {
    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
  } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
  } else if (lib$es6$promise$asap$$isWorker) {
    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
  } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertex();
  } else {
    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
  }

  function lib$es6$promise$$internal$$noop() {}

  var lib$es6$promise$$internal$$PENDING = void 0;
  var lib$es6$promise$$internal$$FULFILLED = 1;
  var lib$es6$promise$$internal$$REJECTED = 2;

  var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();

  function lib$es6$promise$$internal$$selfFullfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }

  function lib$es6$promise$$internal$$cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }

  function lib$es6$promise$$internal$$getThen(promise) {
    try {
      return promise.then;
    } catch (error) {
      lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
      return lib$es6$promise$$internal$$GET_THEN_ERROR;
    }
  }

  function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
    try {
      then.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }

  function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
    lib$es6$promise$asap$$asap(function (promise) {
      var sealed = false;
      var error = lib$es6$promise$$internal$$tryThen(then, thenable, function (value) {
        if (sealed) {
          return;
        }
        sealed = true;
        if (thenable !== value) {
          lib$es6$promise$$internal$$resolve(promise, value);
        } else {
          lib$es6$promise$$internal$$fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }
        sealed = true;

        lib$es6$promise$$internal$$reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));

      if (!sealed && error) {
        sealed = true;
        lib$es6$promise$$internal$$reject(promise, error);
      }
    }, promise);
  }

  function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
    if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
      lib$es6$promise$$internal$$fulfill(promise, thenable._result);
    } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
      lib$es6$promise$$internal$$reject(promise, thenable._result);
    } else {
      lib$es6$promise$$internal$$subscribe(thenable, undefined, function (value) {
        lib$es6$promise$$internal$$resolve(promise, value);
      }, function (reason) {
        lib$es6$promise$$internal$$reject(promise, reason);
      });
    }
  }

  function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
    if (maybeThenable.constructor === promise.constructor) {
      lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
    } else {
      var then = lib$es6$promise$$internal$$getThen(maybeThenable);

      if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
      } else if (then === undefined) {
        lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
      } else if (lib$es6$promise$utils$$isFunction(then)) {
        lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
      } else {
        lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
      }
    }
  }

  function lib$es6$promise$$internal$$resolve(promise, value) {
    if (promise === value) {
      lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFullfillment());
    } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
      lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
    } else {
      lib$es6$promise$$internal$$fulfill(promise, value);
    }
  }

  function lib$es6$promise$$internal$$publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }

    lib$es6$promise$$internal$$publish(promise);
  }

  function lib$es6$promise$$internal$$fulfill(promise, value) {
    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
      return;
    }

    promise._result = value;
    promise._state = lib$es6$promise$$internal$$FULFILLED;

    if (promise._subscribers.length !== 0) {
      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
    }
  }

  function lib$es6$promise$$internal$$reject(promise, reason) {
    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
      return;
    }
    promise._state = lib$es6$promise$$internal$$REJECTED;
    promise._result = reason;

    lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
  }

  function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
    var subscribers = parent._subscribers;
    var length = subscribers.length;

    parent._onerror = null;

    subscribers[length] = child;
    subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
    subscribers[length + lib$es6$promise$$internal$$REJECTED] = onRejection;

    if (length === 0 && parent._state) {
      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
    }
  }

  function lib$es6$promise$$internal$$publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;

    if (subscribers.length === 0) {
      return;
    }

    var child,
        callback,
        detail = promise._result;

    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];

      if (child) {
        lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }

    promise._subscribers.length = 0;
  }

  function lib$es6$promise$$internal$$ErrorObject() {
    this.error = null;
  }

  var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();

  function lib$es6$promise$$internal$$tryCatch(callback, detail) {
    try {
      return callback(detail);
    } catch (e) {
      lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
      return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
    }
  }

  function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
    var hasCallback = lib$es6$promise$utils$$isFunction(callback),
        value,
        error,
        succeeded,
        failed;

    if (hasCallback) {
      value = lib$es6$promise$$internal$$tryCatch(callback, detail);

      if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
        failed = true;
        error = value.error;
        value = null;
      } else {
        succeeded = true;
      }

      if (promise === value) {
        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
      succeeded = true;
    }

    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
      // noop
    } else if (hasCallback && succeeded) {
      lib$es6$promise$$internal$$resolve(promise, value);
    } else if (failed) {
      lib$es6$promise$$internal$$reject(promise, error);
    } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
      lib$es6$promise$$internal$$fulfill(promise, value);
    } else if (settled === lib$es6$promise$$internal$$REJECTED) {
      lib$es6$promise$$internal$$reject(promise, value);
    }
  }

  function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        lib$es6$promise$$internal$$resolve(promise, value);
      }, function rejectPromise(reason) {
        lib$es6$promise$$internal$$reject(promise, reason);
      });
    } catch (e) {
      lib$es6$promise$$internal$$reject(promise, e);
    }
  }

  function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
    var enumerator = this;

    enumerator._instanceConstructor = Constructor;
    enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);

    if (enumerator._validateInput(input)) {
      enumerator._input = input;
      enumerator.length = input.length;
      enumerator._remaining = input.length;

      enumerator._init();

      if (enumerator.length === 0) {
        lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
      } else {
        enumerator.length = enumerator.length || 0;
        enumerator._enumerate();
        if (enumerator._remaining === 0) {
          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
        }
      }
    } else {
      lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
    }
  }

  lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function (input) {
    return lib$es6$promise$utils$$isArray(input);
  };

  lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function () {
    return new Error('Array Methods must be provided an Array');
  };

  lib$es6$promise$enumerator$$Enumerator.prototype._init = function () {
    this._result = new Array(this.length);
  };

  var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;

  lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function () {
    var enumerator = this;

    var length = enumerator.length;
    var promise = enumerator.promise;
    var input = enumerator._input;

    for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
      enumerator._eachEntry(input[i], i);
    }
  };

  lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function (entry, i) {
    var enumerator = this;
    var c = enumerator._instanceConstructor;

    if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
      if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
        entry._onerror = null;
        enumerator._settledAt(entry._state, i, entry._result);
      } else {
        enumerator._willSettleAt(c.resolve(entry), i);
      }
    } else {
      enumerator._remaining--;
      enumerator._result[i] = entry;
    }
  };

  lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function (state, i, value) {
    var enumerator = this;
    var promise = enumerator.promise;

    if (promise._state === lib$es6$promise$$internal$$PENDING) {
      enumerator._remaining--;

      if (state === lib$es6$promise$$internal$$REJECTED) {
        lib$es6$promise$$internal$$reject(promise, value);
      } else {
        enumerator._result[i] = value;
      }
    }

    if (enumerator._remaining === 0) {
      lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
    }
  };

  lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function (promise, i) {
    var enumerator = this;

    lib$es6$promise$$internal$$subscribe(promise, undefined, function (value) {
      enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
    }, function (reason) {
      enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
    });
  };
  function lib$es6$promise$promise$all$$all(entries) {
    return new lib$es6$promise$enumerator$$default(this, entries).promise;
  }
  var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
  function lib$es6$promise$promise$race$$race(entries) {
    /*jshint validthis:true */
    var Constructor = this;

    var promise = new Constructor(lib$es6$promise$$internal$$noop);

    if (!lib$es6$promise$utils$$isArray(entries)) {
      lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
      return promise;
    }

    var length = entries.length;

    function onFulfillment(value) {
      lib$es6$promise$$internal$$resolve(promise, value);
    }

    function onRejection(reason) {
      lib$es6$promise$$internal$$reject(promise, reason);
    }

    for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
      lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
    }

    return promise;
  }
  var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
  function lib$es6$promise$promise$resolve$$resolve(object) {
    /*jshint validthis:true */
    var Constructor = this;

    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
      return object;
    }

    var promise = new Constructor(lib$es6$promise$$internal$$noop);
    lib$es6$promise$$internal$$resolve(promise, object);
    return promise;
  }
  var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
  function lib$es6$promise$promise$reject$$reject(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(lib$es6$promise$$internal$$noop);
    lib$es6$promise$$internal$$reject(promise, reason);
    return promise;
  }
  var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;

  var lib$es6$promise$promise$$counter = 0;

  function lib$es6$promise$promise$$needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }

  function lib$es6$promise$promise$$needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }

  var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
     Terminology
    -----------
     - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
     A promise can be in one of three states: pending, fulfilled, or rejected.
     Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
     Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
      Basic Usage:
    ------------
     ```js
    var promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
       // on failure
      reject(reason);
    });
     promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
     Advanced Usage:
    ---------------
     Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
     ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        var xhr = new XMLHttpRequest();
         xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
         function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
     getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
     Unlike callbacks, promises are great composable primitives.
     ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
       return values;
    });
    ```
     @class Promise
    @param {function} resolver
    Useful for tooling.
    @constructor
  */
  function lib$es6$promise$promise$$Promise(resolver) {
    this._id = lib$es6$promise$promise$$counter++;
    this._state = undefined;
    this._result = undefined;
    this._subscribers = [];

    if (lib$es6$promise$$internal$$noop !== resolver) {
      if (!lib$es6$promise$utils$$isFunction(resolver)) {
        lib$es6$promise$promise$$needsResolver();
      }

      if (!(this instanceof lib$es6$promise$promise$$Promise)) {
        lib$es6$promise$promise$$needsNew();
      }

      lib$es6$promise$$internal$$initializePromise(this, resolver);
    }
  }

  lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
  lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
  lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
  lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
  lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
  lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
  lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;

  lib$es6$promise$promise$$Promise.prototype = {
    constructor: lib$es6$promise$promise$$Promise,

    /**
      The primary way of interacting with a promise is through its `then` method,
      which registers callbacks to receive either a promise's eventual value or the
      reason why the promise cannot be fulfilled.
       ```js
      findUser().then(function(user){
        // user is available
      }, function(reason){
        // user is unavailable, and you are given the reason why
      });
      ```
       Chaining
      --------
       The return value of `then` is itself a promise.  This second, 'downstream'
      promise is resolved with the return value of the first promise's fulfillment
      or rejection handler, or rejected if the handler throws an exception.
       ```js
      findUser().then(function (user) {
        return user.name;
      }, function (reason) {
        return 'default name';
      }).then(function (userName) {
        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
        // will be `'default name'`
      });
       findUser().then(function (user) {
        throw new Error('Found user, but still unhappy');
      }, function (reason) {
        throw new Error('`findUser` rejected and we're unhappy');
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
      });
      ```
      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
       ```js
      findUser().then(function (user) {
        throw new PedagogicalException('Upstream error');
      }).then(function (value) {
        // never reached
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // The `PedgagocialException` is propagated all the way down to here
      });
      ```
       Assimilation
      ------------
       Sometimes the value you want to propagate to a downstream promise can only be
      retrieved asynchronously. This can be achieved by returning a promise in the
      fulfillment or rejection handler. The downstream promise will then be pending
      until the returned promise is settled. This is called *assimilation*.
       ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // The user's comments are now available
      });
      ```
       If the assimliated promise rejects, then the downstream promise will also reject.
       ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // If `findCommentsByAuthor` fulfills, we'll have the value here
      }, function (reason) {
        // If `findCommentsByAuthor` rejects, we'll have the reason here
      });
      ```
       Simple Example
      --------------
       Synchronous Example
       ```javascript
      var result;
       try {
        result = findResult();
        // success
      } catch(reason) {
        // failure
      }
      ```
       Errback Example
       ```js
      findResult(function(result, err){
        if (err) {
          // failure
        } else {
          // success
        }
      });
      ```
       Promise Example;
       ```javascript
      findResult().then(function(result){
        // success
      }, function(reason){
        // failure
      });
      ```
       Advanced Example
      --------------
       Synchronous Example
       ```javascript
      var author, books;
       try {
        author = findAuthor();
        books  = findBooksByAuthor(author);
        // success
      } catch(reason) {
        // failure
      }
      ```
       Errback Example
       ```js
       function foundBooks(books) {
       }
       function failure(reason) {
       }
       findAuthor(function(author, err){
        if (err) {
          failure(err);
          // failure
        } else {
          try {
            findBoooksByAuthor(author, function(books, err) {
              if (err) {
                failure(err);
              } else {
                try {
                  foundBooks(books);
                } catch(reason) {
                  failure(reason);
                }
              }
            });
          } catch(error) {
            failure(err);
          }
          // success
        }
      });
      ```
       Promise Example;
       ```javascript
      findAuthor().
        then(findBooksByAuthor).
        then(function(books){
          // found books
      }).catch(function(reason){
        // something went wrong
      });
      ```
       @method then
      @param {Function} onFulfilled
      @param {Function} onRejected
      Useful for tooling.
      @return {Promise}
    */
    then: function then(onFulfillment, onRejection) {
      var parent = this;
      var state = parent._state;

      if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
        return this;
      }

      var child = new this.constructor(lib$es6$promise$$internal$$noop);
      var result = parent._result;

      if (state) {
        var callback = arguments[state - 1];
        lib$es6$promise$asap$$asap(function () {
          lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
        });
      } else {
        lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
      }

      return child;
    },

    /**
      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
      as the catch block of a try/catch statement.
       ```js
      function findAuthor(){
        throw new Error('couldn't find that author');
      }
       // synchronous
      try {
        findAuthor();
      } catch(reason) {
        // something went wrong
      }
       // async with promises
      findAuthor().catch(function(reason){
        // something went wrong
      });
      ```
       @method catch
      @param {Function} onRejection
      Useful for tooling.
      @return {Promise}
    */
    'catch': function _catch(onRejection) {
      return this.then(null, onRejection);
    }
  };
  function lib$es6$promise$polyfill$$polyfill() {
    var local;

    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }

    var P = local.Promise;

    if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
      return;
    }

    local.Promise = lib$es6$promise$promise$$default;
  }
  var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;

  var lib$es6$promise$umd$$ES6Promise = {
    'Promise': lib$es6$promise$promise$$default,
    'polyfill': lib$es6$promise$polyfill$$default
  };

  /* global define:true module:true window: true */
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return lib$es6$promise$umd$$ES6Promise;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module !== 'undefined' && module['exports']) {
    module['exports'] = lib$es6$promise$umd$$ES6Promise;
  } else if (typeof this !== 'undefined') {
    this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
  }

  lib$es6$promise$polyfill$$default();
}).call(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\process\\browser.js"), __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\timers-browserify\\main.js").setImmediate, __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\global.js")))

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\process\\browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\setimmediate\\setImmediate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\global.js"), __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\process\\browser.js")))

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\timers-browserify\\main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\setimmediate\\setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\global.js")))

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "external \"jQuery\"":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "ignored D:\\a\\1\\s\\node_modules\\es6-promise\\dist vertx":
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "multi D:\\a\\1\\s/client/src/core/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\index.js");


/***/ })

},["multi D:\\a\\1\\s/client/src/core/index.js"]);


// WEBPACK FOOTER //
// scripts/core--96e134bbd09efc8186a0.js